import { MASSTORE, MASSTORETERMINAL, MASSTOREAREA, MASSTOREZONE, MASSTOREREGION, MASSTOREGROUP, MASPRICESHIFT, MASPRICELEVEL, MASCOSTLEVEL } from './../../Classes/mas-store';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpResponse } from '@angular/common/http';
import { MASUSER, MASUSER2, MASUSERGROUP, MASUSERGROUPACCESS, TBLREGISTRATION } from './../../Classes/mas-user';
import { MASCATEGORY, MASBRAND, MASDEPARTMENT, MASGROUP, MASMEASUREMENT, MASSUBDEPARTMENT, MASMEASUREMENTLINK, MASSTOCK, MASSTOCKBARCODE, MASSTOCKPRICE, MASSTOCKCONDIMENT, MASSTOCKPACKAGE, MASSTOCKSETMENU, MASREASON } from './../../Classes/mas-stock';
import { MASSHIFT, MASPAYMENT, MASDISCOUNT, MASMONEYNOTE, MASCONDIMENTLIST, MASCONDIMENTGROUP, MASCONDIMENTLISTPRICE, MASCONDIMENTGROUPSTOCK, MASTAX } from './../../Classes/mas-pos';
import { checkDomain } from '../../Classes/checkDomain';
import { environment } from 'src/environments/environment';
import { MASAUDITTRACK } from 'src/app/Classes/auditTrack';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MessageDialogComponent } from '../../components/dialogs/message-dialog/message-dialog.component';
import { saveAs } from 'file-saver';
import { EMPTY, of } from 'rxjs';
import { PromptService } from '../prompt.service';
import CryptoJS from 'crypto-js';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiURL: string = environment.HTTP + checkDomain() + '.' + environment.API_URL + '/api';
  // apiURL: string = 'https://' + checkDomain()+ '.qubeapi.tk/api';
  // apiURL: string = 'https://pos.api.qubeorder.com.my/api';
  //apiURL: string = 'http://localhost:8008/api';
  //apiURL : string = "https://127.0.0.1:8008/api";


  constructor(private http: HttpClient, private messageDialog: MatDialog, private promptService: PromptService) { }

  public checkSubdomain(subdomain: any){
    return this.http.get<any>(`${environment.HTTP}${environment.API_URL}/api/domain?domain=${subdomain}`);
  }



  //#region login and token

  public Login(userName: string, password: string, os: any) {
    return this.http.post<any>(`${this.apiURL}/login`, { domain: checkDomain(), email: userName, password: password, os: os });
  }

  public Logout() {
    return this.http.post<any>(`${this.apiURL}/logout`, null);
  }

  public CheckTokenValidity() {
    return this.http.get<any>(`${this.apiURL}/validity`);
  }

  public getbyemailsMY(userName: string) {
    return this.http.get<any>(`${this.apiURL}/user/getbyemails/${userName}`);

  }

  public getAllByEmailMY(userEmail: string) {
    return this.http.get<any>(`${this.apiURL}/user/getAllbyemails/${userEmail}`);

  }

  //#endregion

  //#region store

  //#region store

  public GetStores() {
    return this.http.get<any>(`${this.apiURL}/store`);
  }

  public AddStore(store: MASSTORE) {
    return this.http.put<any>(`${this.apiURL}/store/insert`, store);
  }

  public UpdateStore(store: MASSTORE) {
    return this.http.put<any>(`${this.apiURL}/store/update`, store);
  }

  public DelStore(store: MASSTORE) {
    return this.http.put<any>(`${this.apiURL}/store/delete`, store);
  }

  public GetStoreById(id: string) {
    return this.http.get<any>(`${this.apiURL}/store/${id}`);
  }

  public DeleteTerminalOfStore(store: MASSTORE) {
    return this.http.put<any>(`${this.apiURL}/store/delete/storeterminal`, store);
  }

  //#endregion

  //#region store zone

  public GetStoreZones() {
    return this.http.get<any>(`${this.apiURL}/storezone`);
  }

  public AddStoreZone(zone: MASSTOREZONE) {
    return this.http.put<any>(`${this.apiURL}/storezone/insert`, zone);
  }

  public UpdateStoreZone(zone: MASSTOREZONE) {
    return this.http.put<any>(`${this.apiURL}/storezone/update`, zone);
  }

  public DelStoreZoneWithRegionsAreas(region: MASSTOREZONE) {
    return this.http.put<any>(`${this.apiURL}/storezone/delete/region`, region);
  }

  //#endregion

  //#region store region

  public GetStoreRegions() {
    return this.http.get<any>(`${this.apiURL}/storeregion`);
  }

  public GetStoreRegionByZone(zoneCode: string) {
    return this.http.get<any>(`${this.apiURL}/storeregion/${zoneCode}`);
  }

  public AddStoreRegion(region: MASSTOREREGION) {
    return this.http.put<any>(`${this.apiURL}/storeregion/insert`, region);
  }

  public UpdateStoreRegion(region: MASSTOREREGION) {
    return this.http.put<any>(`${this.apiURL}/storeregion/update`, region);
  }

  public DelStoreRegionWithAreas(region: MASSTOREREGION) {
    return this.http.put<any>(`${this.apiURL}/storeregion/delete/area`, region);
  }

  //#endregion

  //#region store area

  public GetStoreAreas() {
    return this.http.get<any>(`${this.apiURL}/storearea`);
  }

  public GetStoreAreasByZone(zoneCode: string) {
    return this.http.get<any>(`${this.apiURL}/storearea/${zoneCode}`);
  }

  public GetStoreAreasByZoneRegion(zoneCode: string, regionCode: string) {
    return this.http.get<any>(`${this.apiURL}/storearea/${zoneCode}/${regionCode}`);
  }

  public AddStoreArea(area: MASSTOREAREA) {
    return this.http.put<any>(`${this.apiURL}/storearea/insert`, area);
  }

  public UpdateStoreArea(area: MASSTOREAREA) {
    return this.http.put<any>(`${this.apiURL}/storearea/update`, area);
  }

  public DelStoreArea(area: MASSTOREAREA) {
    return this.http.put<any>(`${this.apiURL}/storearea/delete`, area);
  }

  //#endregion

  //#region store group

  public GetStoreGroups() {
    return this.http.get<any>(`${this.apiURL}/storegroup`);
  }

  public AddStoreGroup(group: MASSTOREGROUP) {
    return this.http.put<any>(`${this.apiURL}/storegroup/insert`, group);
  }

  public UpdateStoreGroup(group: MASSTOREGROUP) {
    return this.http.put<any>(`${this.apiURL}/storegroup/update`, group);
  }

  public DelStoreGroup(group: MASSTOREGROUP) {
    return this.http.put<any>(`${this.apiURL}/storegroup/delete`, group);
  }

  //#endregion

  //#region price shift

  public GetPriceShift() {
    return this.http.get<any>(`${this.apiURL}/priceshift`);
  }

  public UpdatePriceShift(priceShift: MASPRICESHIFT) {
    return this.http.put<any>(`${this.apiURL}/priceshift/update`, priceShift);
  }

  public AddPriceShift(priceShift: MASPRICESHIFT) {
    return this.http.put<any>(`${this.apiURL}/priceshift/insert`, priceShift);
  }

  public DeletePriceShift(priceShift: MASPRICESHIFT) {
    return this.http.put<any>(`${this.apiURL}/priceshift/delete`, priceShift);
  }

  //#endregion

  //#region price level

  public GetPriceLevel() {
    return this.http.get<any>(`${this.apiURL}/pricelvl`);
  }

  public UpdatePriceLevel(priceLevel: MASPRICELEVEL) {
    return this.http.put<any>(`${this.apiURL}/pricelvl/update`, priceLevel);
  }

  public AddPriceLevel(priceLevel: MASPRICELEVEL) {
    return this.http.put<any>(`${this.apiURL}/pricelvl/insert`, priceLevel);
  }

  public DeletePriceLevel(priceLevel: MASPRICELEVEL) {
    return this.http.put<any>(`${this.apiURL}/pricelvl/delete`, priceLevel);
  }

  //#endregion

  //#region cost level

  public GetCostLevel() {
    return this.http.get<any>(`${this.apiURL}/costlvl`);
  }

  public UpdateCostLevel(costLevel: MASCOSTLEVEL) {
    return this.http.put<any>(`${this.apiURL}/costlvl/update`, costLevel);
  }

  public AddCostLevel(costLevel: MASCOSTLEVEL) {
    return this.http.put<any>(`${this.apiURL}/costlvl/insert`, costLevel);
  }

  public DeleteCostLevel(costLevel: MASCOSTLEVEL) {
    return this.http.put<any>(`${this.apiURL}/costlvl/delete`, costLevel);
  }

  //#endregion

  //#region store terminal

  public GetStoreTerminal() {
    return this.http.get<any>(`${this.apiURL}/storeterminal`);
  }

  public GetStoreTerminalByStore(storeCode: string) {
    return this.http.get<any>(`${this.apiURL}/storeterminal/${storeCode}`);
  }

  public UpdateTerminal(terminal: MASSTORETERMINAL) {
    return this.http.put<any>(`${this.apiURL}/storeterminal/update`, terminal);
  }

  public AddTerminal(terminal: MASSTORETERMINAL) {
    return this.http.put<any>(`${this.apiURL}/storeterminal/insert`, terminal);
  }

  public DeleteTerminal(terminal: MASSTORETERMINAL) {
    return this.http.put<any>(`${this.apiURL}/storeterminal/delete`, terminal);
  }

  //#endregion

  //#endregion

  //#region user

  //#region user

  public GetUser() {
    return this.http.get<any>(`${this.apiURL}/user`);
  }

  public AddUser(user: MASUSER) {
    return this.http.put<any>(`${this.apiURL}/user/insert`, user);
  }

  public UploadUserImage(file: File, M_CODE: string) {
    const fd = new FormData();
    fd.append('M_PHOTO', file, file.name);
    fd.append('M_CODE', M_CODE);
    return this.http.post<any>(`${this.apiURL}/user/insertImage`, fd);
  }

  public UpdateUser(user: MASUSER) {
    return this.http.put<any>(`${this.apiURL}/user/update`, user);
  }

  public DeleteUser(user: MASUSER2) {
    return this.http.put<any>(`${this.apiURL}/user/delete`, user);
  }

  
  public GetUserByID(id: any) {
    return this.http.get<any>(`${this.apiURL}/user/getbyid/${id}`);
  }
  //#endregion

  //#region user group

  public GetUserGroup() {
    return this.http.get<any>(`${this.apiURL}/usergroup`);
  }

  public AddUserGroup(user: MASUSERGROUP) {
    return this.http.put<any>(`${this.apiURL}/usergroup/insert`, user);
  }

  public UpdateUserGroup(user: MASUSERGROUP) {
    return this.http.put<any>(`${this.apiURL}/usergroup/update`, user);
  }

  public DeleteUserGroup(user: MASUSERGROUP) {
    return this.http.put<any>(`${this.apiURL}/usergroup/delete`, user);
  }

  public GetRoleList(type: any) {
    return this.http.get<any>(`${this.apiURL}/acl/roles/grouped-type?type=${type}`);
  }

  public GetRoleToAssign(){
    return this.http.get<any>(`${this.apiURL}/acl/roles`);
  }

  public GetUserPortalRole(user_id: string){
    return this.http.get<any>(`${this.apiURL}/acl/user/${user_id}`);
  }

  
  public GetUserList() {
    return this.http.get<any>(`${this.apiURL}/acl/roles/grouped-users?type=all`);
  }

  //#endregion

  //#region user group access

  public GetUserGroupAccess(userGroup: string) {
    //userGroup = 'admin'
    // if (userGroup === '') {
    //   userGroup = 'admin';
    // }
    
    return this.http.get<any>(`${this.apiURL}/useraccess/${userGroup}`);
  }

  public AddUserGroupAccess(userGroup: string) {
    return this.http.put<any>(`${this.apiURL}/useraccess/insert`, { M_USER_GROUP: userGroup });
  }

  public UpdateUserGroupAccess(userGroupAccess: MASUSERGROUPACCESS[]) {
    return this.http.put<any>(`${this.apiURL}/useraccess/update`, userGroupAccess);
  }

  //#endregion

  //#region user group pos

  public GetUserGroupPosAccess(userGroup: string) {
    return this.http.get<any>(`${this.apiURL}/userpos/${userGroup}`);
  }

  public AddUserGroupPosAccess(userGroup: string) {
    return this.http.put<any>(`${this.apiURL}/userpos/insert`, { M_USER_GROUP: userGroup });
  }

  public UpdateUserGroupPosAccess(userGroupAccess: MASUSERGROUPACCESS[]) {
    return this.http.put<any>(`${this.apiURL}/userpos/update`, userGroupAccess);
  }

  //#endregion

  //#region user group report

  public GetUserGroupReportAccess(userGroup: string) {
    return this.http.get<any>(`${this.apiURL}/userreport/${userGroup}`);
  }

  public AddUserGroupReportAccess(userGroup: string) {
    return this.http.put<any>(`${this.apiURL}/userreport/insert`, { M_USER_GROUP: userGroup });
  }

  public UpdateUserGroupReportAccess(userGroupAccess: MASUSERGROUPACCESS[]) {
    return this.http.put<any>(`${this.apiURL}/userreport/update`, userGroupAccess);
  }

  //#endregion

  //#endregion

  //#region stock 

  public GetAllStockPackageData()
  {
    return this.http.get<any>(`${this.apiURL}/stockdetail`);
  }

  public GetStock() {

    return this.http.get<any>(`${this.apiURL}/stock`);
  }

  public GetStockByCode(code: string) {

    return this.http.get<any>(`${this.apiURL}/stock/code/${code}`);
  }


  public AddStock(stock: MASSTOCK) {
    
    return this.http.put<any>(`${this.apiURL}/stock/insert`, stock);
  }

  public UpdateStock(stock: MASSTOCK) {
    return this.http.put<any>(`${this.apiURL}/stock/update`, stock);
  }


  public upsertStock(isInsert: boolean, data: any){
    return this.http.put<any>(`${this.apiURL}/stock/${isInsert ? 'insert' : 'update'}`, data);

  }
  public DeleteStock(stock: MASSTOCK) {
    return this.http.put<any>(`${this.apiURL}/stock/delete`, stock);
  }

  public GetStockBalance(params: { M_STOCK_ID: string, M_STOCK_CODE: string, S_STORE: string}) {

    return this.http.get<any>(`${this.apiURL}/stock/store-balance`, {params});
  }

  public UploadStockImage(file: File, M_STOCK_ID: string, fileName?: string) {
    const fd = new FormData();
    fd.append('M_PHOTO', file, fileName);
    fd.append('M_STOCK_ID', M_STOCK_ID);

    return this.http.post<any>(`${this.apiURL}/stock/insertImage`, fd);
  }

  public UploadStockImageV2(file: File, M_STOCK_ID: string, fileName?: string) {
    const fd = new FormData();
    fd.append('M_PHOTO', file, fileName);
    fd.append('M_STOCK_ID', M_STOCK_ID);

    return this.http.post<any>(`${this.apiURL}/stock/insertItemImage`, fd);
  }

  
  public deleteStockImage(M_STOCK_ID: string) {
    let formData = {
      M_STOCK_ID
    }
    return this.http.post<any>(`${this.apiURL}/stock/deleteItemImage`, formData);
  }

  
  public getStockImage(M_PHOTO: string, M_STOCK_ID: string, system: string) {

    if (M_PHOTO === ''){
      return of({});
    }
    else {
      let params = {
        M_STOCK_ID,
        system,
      }

      return this.http.get<any>(`${this.apiURL}/stock/itemImages`, {params});

    }

  }

  
  public getPresetList(M_STOCK_ID: string)
  {
    return this.http.get<any>(`${this.apiURL}/stock-package-preset-menu?M_STOCK_ID=${M_STOCK_ID}`);
  }

  public getItemList(search: string)
  {
    return this.http.get<any>(`${this.apiURL}/dropdown/mas-stock?search=${search}`);
  }

  
  public insertMenuItem(apiData: any)
  {
    return this.http.post<any>(`${this.apiURL}/stock-package-preset-menu/upsert-items`, apiData);
  }
  public getMenuItem(M_STOCK_ID: string, M_STOCK_ID_PACKAGE: string)
  {
    return this.http.get<any>(`${this.apiURL}/stock-package-preset-menu/by-code?M_STOCK_ID=${M_STOCK_ID}&M_STOCK_ID_PACKAGE=${M_STOCK_ID_PACKAGE}`);
  }
  public deleteMenuItem(M_STOCK_ID: string, M_STOCK_ID_PACKAGE: string)
  {
    return this.http.delete<any>(`${this.apiURL}/stock-package-preset-menu/delete-item-by-code?M_STOCK_ID=${M_STOCK_ID}&M_STOCK_ID_PACKAGE=${M_STOCK_ID_PACKAGE}`);
  }

  //#region stock barcode

  public GetBarcodeByStockCode(stockCode: string) {
    return this.http.get<any>(`${this.apiURL}/stockbarcode/${stockCode}`);
  }

  public AddBarcode(barcode: MASSTOCKBARCODE) {
    return this.http.put<any>(`${this.apiURL}/stockbarcode/insert`, barcode);
  }

  public UpdateBarcode(barcode: MASSTOCKBARCODE) {
    return this.http.put<any>(`${this.apiURL}/stockbarcode/update`, barcode);
  }

  public DeleteBarcode(barcode: MASSTOCKBARCODE) {
    return this.http.put<any>(`${this.apiURL}/stockbarcode/delete`, barcode);
  }

  //#endregion

  //#region stock price

  public GetStockPriceByStockCode(stockCode: string) {
    return this.http.get<any>(`${this.apiURL}/stockprice/stockid/${stockCode}`);
  }

  public AddStockPrice(price: MASSTOCKPRICE) {
    return this.http.put<any>(`${this.apiURL}/stockprice/insert`, price);
  }

  public UpdateStockPrice(price: MASSTOCKPRICE) {
    class STOCKPRICE {
      M_STOCK_ID: string = "";
      M_PRICE_LEVEL: string = "";
      M_STOCK_CODE: string = "";
      M_P_S1: number = 0;
      M_P_S2: number = 0;
      M_P_S3: number = 0;
      M_P_S4: number = 0;
      M_P_S5: number = 0;
      M_P_S6: number = 0;
      M_P_S7: number = 0;
      M_P_S8: number = 0;
      M_P_S9: number = 0;
      M_P_MIN_PRICE: number = 0;
      M_STATUS: string = "";
      M_PROMOTION_ID_S1: string = "";
      M_PROMOTION_ID_S2: string = "";
      M_PROMOTION_ID_S3: string = "";
      M_PROMOTION_ID_S4: string = "";
      M_PROMOTION_ID_S5: string = "";
      M_PROMOTION_ID_S6: string = "";
      M_PROMOTION_ID_S7: string = "";
      M_PROMOTION_ID_S8: string = "";
      M_PROMOTION_ID_S9: string = "";
      M_USER_UPDATE: string = "";
      M_DATE_UPDATE: Date = new Date();
      M_DATE_INSERT: Date = new Date();
    }

    let stockPrice: STOCKPRICE = new STOCKPRICE();

    stockPrice.M_STOCK_ID = price.M_STOCK_ID;
    stockPrice.M_PRICE_LEVEL = price.M_PRICE_LEVEL;
    stockPrice.M_STOCK_CODE = price.M_STOCK_CODE;
    stockPrice.M_P_S1 = price.M_P_S1;
    stockPrice.M_P_S2 = price.M_P_S2;
    stockPrice.M_P_S3 = price.M_P_S3;
    stockPrice.M_P_S4 = price.M_P_S4;
    stockPrice.M_P_S5 = price.M_P_S5;
    stockPrice.M_P_S6 = price.M_P_S6;
    stockPrice.M_P_S7 = price.M_P_S7;
    stockPrice.M_P_S8 = price.M_P_S8;
    stockPrice.M_P_S9 = price.M_P_S9;
    stockPrice.M_P_MIN_PRICE = price.M_P_MIN_PRICE;
    stockPrice.M_STATUS = price.M_STATUS;
    stockPrice.M_PROMOTION_ID_S1 = price.M_PROMOTION_ID_S1;
    stockPrice.M_PROMOTION_ID_S2 = price.M_PROMOTION_ID_S2;
    stockPrice.M_PROMOTION_ID_S3 = price.M_PROMOTION_ID_S3;
    stockPrice.M_PROMOTION_ID_S4 = price.M_PROMOTION_ID_S4;
    stockPrice.M_PROMOTION_ID_S5 = price.M_PROMOTION_ID_S5;
    stockPrice.M_PROMOTION_ID_S6 = price.M_PROMOTION_ID_S6;
    stockPrice.M_PROMOTION_ID_S7 = price.M_PROMOTION_ID_S7;
    stockPrice.M_PROMOTION_ID_S8 = price.M_PROMOTION_ID_S8;
    stockPrice.M_PROMOTION_ID_S9 = price.M_PROMOTION_ID_S9;
    stockPrice.M_USER_UPDATE = price.M_USER_UPDATE;
    stockPrice.M_DATE_UPDATE = price.M_DATE_UPDATE;
    stockPrice.M_DATE_INSERT = price.M_DATE_INSERT;

    return this.http.put<any>(`${this.apiURL}/stockprice/update`, stockPrice);
  }

  public DeleteStockPrice(price: MASSTOCKPRICE) {
    return this.http.put<any>(`${this.apiURL}/stockprice/delete`, price);
  }

  //#endregion

  //#region stock condiment

  public GetStockCondimentByCode(stockCode: string) {
    return this.http.get<any>(`${this.apiURL}/stockcondiment/${stockCode}`);
  }

  public AddStockCondiment(condiment: MASSTOCKCONDIMENT[]) {
    return this.http.put<any>(`${this.apiURL}/stockcondiment/insert`, condiment);
  }

  public UpdateStockCondiment(condiment: MASSTOCKCONDIMENT[]) {
    return this.http.put<any>(`${this.apiURL}/stockcondiment/update`, condiment);
  }

  public DeleteStockCondiment(condiment: MASSTOCKCONDIMENT[]) {
    return this.http.put<any>(`${this.apiURL}/stockcondiment/delete`, condiment);
  }

  //#endregion

  //#region stock package

  public GetStockSetmenuByCode(stockCode: string) {
    return this.http.get<any>(`${this.apiURL}/stocksetmenu/${stockCode}`);
  }

  public AddStockSetmenu(stockSetmenu: MASSTOCKSETMENU[]) {
    return this.http.put<any>(`${this.apiURL}/stocksetmenu/insert`, stockSetmenu);
  }

  public UpdateStockSetmenu(stockSetmenu: MASSTOCKSETMENU[]) {
    return this.http.put<any>(`${this.apiURL}/stocksetmenu/update`, stockSetmenu);
  }

  public DeleteStockSetmenu(stockSetmenu: MASSTOCKSETMENU[]) {
    return this.http.put<any>(`${this.apiURL}/stocksetmenu/delete`, stockSetmenu);
  }

  public GetSetMenuInStock(id: string, code: string) {
    const params = new HttpParams()
      .set('M_STOCK_ID', id)
      .set('M_STOCK_CODE', code);
    return this.http.get<any>(`${this.apiURL}/stock/edit`, { params });
  }

  //#endregion

  //#region stock package

  public GetStockPackageByCode(stockCode: string) {
    return this.http.get<any>(`${this.apiURL}/stockpackage/${stockCode}`);
  }

  public AddStockPackage(stockPackage: MASSTOCKPACKAGE[]) {
    return this.http.put<any>(`${this.apiURL}/stockpackage/insert`, stockPackage);
  }

  public UpdateStockPackage(stockPackage: MASSTOCKPACKAGE[]) {
    return this.http.put<any>(`${this.apiURL}/stockpackage/update`, stockPackage);
  }

  public DeleteStockPackage(stockPackage: MASSTOCKPACKAGE[]) {
    return this.http.put<any>(`${this.apiURL}/stockpackage/delete`, stockPackage);
  }

  //#endregion

  //#region stock category

  public GetCategory() {
    return this.http.get<any>(`${this.apiURL}/category`);
  }

  public AddCategory(category: MASCATEGORY) {
    return this.http.put<any>(`${this.apiURL}/category/insert`, category);
  }

  public UpdateCategory(category: MASCATEGORY) {
    return this.http.put<any>(`${this.apiURL}/category/update`, category);
  }

  public DeleteCategory(category: MASCATEGORY) {
    return this.http.put<any>(`${this.apiURL}/category/delete`, category);
  }

  //#endregion

  //#region stock category

  public GetBrand() {
    return this.http.get<any>(`${this.apiURL}/brand`);
  }

  public AddBrand(brand: MASBRAND) {
    return this.http.put<any>(`${this.apiURL}/brand/insert`, brand);
  }

  public UpdateBrand(brand: MASBRAND) {
    return this.http.put<any>(`${this.apiURL}/brand/update`, brand);
  }

  public DeleteBrand(brand: MASBRAND) {
    return this.http.put<any>(`${this.apiURL}/brand/delete`, brand);
  }

  //#endregion

  //#region stock group

  public GetGroup() {
    return this.http.get<any>(`${this.apiURL}/group`);
  }

  public AddGroup(group: MASGROUP) {
    return this.http.put<any>(`${this.apiURL}/group/insert`, group);
  }

  public UpdateGroup(group: MASGROUP) {
    return this.http.put<any>(`${this.apiURL}/group/update`, group);
  }

  public DeleteGroup(group: MASGROUP) {
    return this.http.put<any>(`${this.apiURL}/group/delete`, group);
  }

  public DeleteGroupWithDept(group: MASGROUP) {
    return this.http.put<any>(`${this.apiURL}/group/delete/department`, group);
  }

  //#endregion

  //#region stock department

  public GetDepartment() {
    return this.http.get<any>(`${this.apiURL}/department`);
  }

  public AddDepartment(dept: MASDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/department/insert`, dept);
  }

  public UpdateDepartment(dept: MASDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/department/update`, dept);
  }

  public DeleteDepartment(dept: MASDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/department/delete`, dept);
  }

  public DeleteDepartmentWithSubDept(dept: MASDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/department/delete/subdepartment`, dept);
  }

  public GetDepartmentsByGroup(group: string) {
    return this.http.get<any>(`${this.apiURL}/department/${group}`);
  }

  //#endregion

  //#region stock sub department

  public GetSubDepartment() {
    return this.http.get<any>(`${this.apiURL}/subdepartment`);
  }

  public AddSubDepartment(subDept: MASSUBDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/subdepartment/insert`, subDept);
  }

  public UpdateSubDepartment(subDept: MASSUBDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/subdepartment/update`, subDept);
  }

  public DeleteSubDepartment(subDept: MASSUBDEPARTMENT) {
    return this.http.put<any>(`${this.apiURL}/subdepartment/delete`, subDept);
  }

  public GetSubDepartmentsByGroupAndDepartment(group: string, dept: string) {
    return this.http.get<any>(`${this.apiURL}/subdepartment/${group}/${dept}`);
  }

  //#endregion

  //#region stock measurement

  public GetMeasurement() {
    return this.http.get<any>(`${this.apiURL}/measurement`);
  }

  public AddMeasurement(measurement: MASMEASUREMENT) {
    return this.http.put<any>(`${this.apiURL}/measurement/insert`, measurement);
  }

  public UpdateMeasurement(measurement: MASMEASUREMENT) {
    return this.http.put<any>(`${this.apiURL}/measurement/update`, measurement);
  }

  public DeleteMeasurement(measurement: MASMEASUREMENT) {
    return this.http.put<any>(`${this.apiURL}/measurement/delete`, measurement);
  }

  //#endregion

  //#region stock measurement link

  public GetMeasurementLink() {
    return this.http.get<any>(`${this.apiURL}/measurementlink`);
  }

  public AddMeasurementLink(measurementLink: MASMEASUREMENTLINK) {
    return this.http.put<any>(`${this.apiURL}/measurementlink/insert`, measurementLink);
  }

  public UpdateMeasurementLink(measurementLink: MASMEASUREMENTLINK) {
    return this.http.put<any>(`${this.apiURL}/measurementlink/update`, measurementLink);
  }

  public DeleteMeasurementLink(measurementLink: MASMEASUREMENTLINK) {
    return this.http.put<any>(`${this.apiURL}/measurementlink/delete`, measurementLink);
  }

  public GetMeasurementLinksByMeasurementCode(measurementCode: string) {
    return this.http.get<any>(`${this.apiURL}/measurementlink/${measurementCode}`);
  }

  //#endregion
    

  //#region stock settings
  public GetStockTaxSettings() {
    return this.http.get<any>(`${this.apiURL}/stock/settings/global-tax`);
  }
  public UpdateStockTaxSetting(stockTaxSetting: any) {
    return this.http.post<any>(`${this.apiURL}/stock/settings/global-tax`, stockTaxSetting);
  }
  public ApplyStockTaxSetting() {
    return this.http.post<any>(`${this.apiURL}/stock/settings/apply`, []);
  }

  public calculateStockMargin(formData: any) {
    return this.http.post<any>(`${this.apiURL}/stock/calc-margin`, formData);
  }
  //#endregion

  //#endregion

  //#region pos

  //#region shift

  public GetShift() {
    return this.http.get<any>(`${this.apiURL}/shift`);
  }

  public AddShift(shift: MASSHIFT) {
    return this.http.put<any>(`${this.apiURL}/shift/insert`, shift);
  }

  public UpdateShift(shift: MASSHIFT) {
    return this.http.put<any>(`${this.apiURL}/shift/update`, shift);
  }

  public DeleteShift(shift: MASSHIFT) {
    return this.http.put<any>(`${this.apiURL}/shift/delete`, shift);
  }

  //#endregion

    //#region reason

    public GetReason() {
      return this.http.get<any>(`${this.apiURL}/reason`);
    }
  
    public AddReason(reason: MASREASON) {
      return this.http.post<any>(`${this.apiURL}/reason/store`, reason);
    }

    public EditReason(reason: MASREASON) {
      return this.http.get<any>(`${this.apiURL}/reason/edit`);
    }
  
    public UpdateReason(reason: MASREASON) {
      return this.http.post<any>(`${this.apiURL}/reason/update`, reason);
    }
  
    public DeleteReason(reason: MASREASON) {
      return this.http.post<any>(`${this.apiURL}/reason/delete`, reason);
    }
  
    //#endregion

  //#region voucher


  public AddVoucher(voucher:any) {
    return this.http.post<any>(`${this.apiURL}/serialized/voucher/store`, voucher);
  }

  public UpdateVoucher(voucher: any) {
    return this.http.post<any>(`${this.apiURL}/serialized/voucher/update`, voucher);
  }

  public EditVoucher(id:any) {
    return this.http.get<any>(`${this.apiURL}/serialized/voucher/edit?id=${id}`);
  }

  public GetVoucher(item:number,page:number, searchResult:string, sPrefix:boolean,sPriority:boolean, sTitle:boolean, sType:boolean, sStartDate:boolean, sEndDate:boolean, sStatus:boolean, sortName:any) {

    const params:any = {
      page: page,
      item:item,
      search:searchResult
    };

    if(sortName !== '')
      {
        switch (sortName) {
        case 'prefix':
          params.s_prefix = sPrefix;
          break;
        case 'priority':
          params.s_priority = sPriority;
          break;
        case 'title':
          params.s_title = sTitle;
          break;
        case 'type':
          params.s_type = sType;
          break;
        case 'start_date':
          params.s_start_date = sStartDate;
          break;
        case 'end_date':
          params.s_end_date = sEndDate;
          break;
        case 'status':
          params.s_status = sStatus;
          break;
        
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }

    return this.http.get<any>(`${this.apiURL}/serialized/voucher`, { params });
  }

  public GetVoucherAreas() {
    return this.http.get<any>(`${this.apiURL}/serialized/voucher/create`);
  }

  public GetVoucherStore(codeArea:any) {
    return this.http.get<any>(`${this.apiURL}/serialized/voucher/getstore?area=["${codeArea}"]`);
  }

  public ExportVoucher(item: number, page: number, searchResult: string, sPrefix: boolean, sPriority: boolean, 
    sTitle: boolean, sType: boolean, sStartDate: boolean, sEndDate: boolean, sStatus: boolean, sortName: string) {

    let params = new HttpParams()
    .set('page', page)
    .set('item', item)
    .set('search', searchResult);

    if (sortName) {
    switch (sortName) {
    case 'prefix':
    params = params.set('s_prefix', sPrefix.toString());
    break;
    case 'priority':
    params = params.set('s_priority', sPriority.toString());
    break;
    case 'title':
    params = params.set('s_title', sTitle.toString());
    break;
    case 'type':
    params = params.set('s_type', sType.toString());
    break;
    case 'start_date':
    params = params.set('s_start_date', sStartDate.toString());
    break;
    case 'end_date':
    params = params.set('s_end_date', sEndDate.toString());
    break;
    case 'status':
    params = params.set('s_status', sStatus.toString());
    break;
    default:
    break;
    }
    }

    return this.http.get(`${this.apiURL}/serialized/voucher/export`, { params, responseType: 'text' });
  }

  public GetPerformance(item:number,page:number, startDate:any, endDate:any) {

    const params:any = {
      page: page,
      item:item,
      start_date: startDate,
      end_date:endDate,
    };

    return this.http.get<any>(`${this.apiURL}/serialized/voucher/dashboard`, {params});
  }

  public GetCampaign(item:number,page:number) {

    const params:any = {
      page: page,
      item:item
    };

    return this.http.get<any>(`${this.apiURL}/serialized/campaigns?`, {params});
  }

  public GetVoucherList(type:string, item:number, page:number, startDate:any, endDate:any, sSerial:boolean, sExpiry:boolean, sAmount:boolean, sStore:boolean, sReceiptAmount:boolean, sReceiptStatus:boolean, sStatus:boolean, sRedempDate:boolean, sRedemptReceiptStatus:boolean, sRedempStoreIssued:boolean, sortName:any) {

    const params:any = {
      type: type,
      page: page,
      item:item,
      start_date: startDate,
      end_date:endDate,
    };

    if(sortName !== '')
      {
        switch (sortName) {
        case 'serial':
          params.s_voucher_code = sSerial;
          break;
        case 'expiry':
            params.s_expiry_date = sExpiry;
            break;
        case 'amount':
          params.s_amount = sAmount;
          break;
        case 'store':
          params.s_generated_store_code = sStore;
          break;
        case 'receiptAmount':
          params.s_generate_receipt_amount = sReceiptAmount;
          break;
        case 'receiptStatus':
          params.s_generate_receipt_status = sReceiptStatus;
          break;
        case 'status':
          params.s_status = sStatus;
          break;
        case 'redempDate':
          params.s_redemption_date = sRedempDate;
          break;
        case 'redempReceiptAmount':
          params.s_redemption_receipt_amount = sRedemptReceiptStatus;
          break;
        case 'redempStoreIssued':
          params.s_redemption_store_code = sRedempStoreIssued;
          break;
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }

    return this.http.get<any>(`${this.apiURL}/serialized/voucher/lists?`, {params});
  }

  public GetCampaignList(id:number, item:number, page:number, sSerial:boolean, sExpiry:boolean, sAmount:boolean, sStore:boolean, sReceiptAmount:boolean, sReceiptStatus:boolean, sStatus:boolean, sRedempDate:boolean, sRedemptReceiptStatus:boolean, sRedempStoreIssued:boolean, sortName:any) {

    const params:any = {
      mas_serialized_voucher_id: id,
      page: page,
      item:item,
    };

    if(sortName !== '')
      {
        switch (sortName) {
        case 'serial':
          params.s_voucher_code = sSerial;
          break;
        case 'expiry':
            params.s_expiry_date = sExpiry;
            break;
        case 'amount':
          params.s_amount = sAmount;
          break;
        case 'store':
          params.s_generated_store_code = sStore;
          break;
        case 'receiptAmount':
          params.s_generate_receipt_amount = sReceiptAmount;
          break;
        case 'receiptStatus':
          params.s_generate_receipt_status = sReceiptStatus;
          break;
        case 'status':
          params.s_status = sStatus;
          break;
        case 'redempDate':
          params.s_redemption_date = sRedempDate;
          break;
        case 'redempReceiptAmount':
          params.s_redemption_receipt_amount = sRedemptReceiptStatus;
          break;
        case 'redempStoreIssued':
          params.s_redemption_store_code = sRedempStoreIssued;
          break;
        default:
          // Handle any other cases or provide a default behavior if needed.
          break;
        }
      }

    return this.http.get<any>(`${this.apiURL}/serialized/campaigns/lists?`, {params});
  }

  public ExportCampaign() {
    return this.http.get(`${this.apiURL}/serialized/campaigns/voucher`, {
      responseType: 'blob' // Handles binary data properly
    });
  }
  

  //#region payment

  public GetPayment() {
    return this.http.get<any>(`${this.apiURL}/paymentin`);
  }

  public AddPayment(payment: MASPAYMENT) {
    return this.http.put<any>(`${this.apiURL}/paymentin/insert`, payment);
  }

  public UploadPaymentImage(file: File, M_CODE: string) {
    const fd = new FormData();
    fd.append('M_PHOTO', file, file.name);
    fd.append('M_CODE', M_CODE);
    return this.http.post<any>(`${this.apiURL}/paymentin/insertImage`, fd);
  }

  public UpdatePayment(payment: MASPAYMENT) {
    return this.http.put<any>(`${this.apiURL}/paymentin/update`, payment);
  }

  public DeletePayment(payment: MASPAYMENT) {
    return this.http.put<any>(`${this.apiURL}/paymentin/delete`, payment);
  }

  //#endregion

  //#region discount

  public GetDiscount() {
    return this.http.get<any>(`${this.apiURL}/discount`);
  }

  public AddDiscount(discount: MASDISCOUNT) {
    return this.http.post<any>(`${this.apiURL}/discount/insert`, discount);
  }

  public UpdateDiscount(discount: MASDISCOUNT) {
    return this.http.post<any>(`${this.apiURL}/discount/update`, discount);
  }

  public DeleteDiscount(discount: MASDISCOUNT) {
    return this.http.post<any>(`${this.apiURL}/discount/delete`, discount);
  }

  //#endregion

  //#region money note

  public GetMoneyNote() {
    return this.http.get<any>(`${this.apiURL}/moneynote`);
  }

  public AddMoneyNote(moneynote: MASMONEYNOTE) {
    return this.http.post<any>(`${this.apiURL}/moneynote/insert`, moneynote);
  }

  public UpdateMoneyNote(moneynote: MASMONEYNOTE) {
    return this.http.post<any>(`${this.apiURL}/moneynote/update`, moneynote);
  }

  public DeleteMoneyNote(moneynote: MASMONEYNOTE) {
    return this.http.post<any>(`${this.apiURL}/moneynote/delete`, moneynote);
  }

  //#endregion

  //#region condiment list

  public GetCondimentList() {
    return this.http.get<any>(`${this.apiURL}/condimentlist`);
  }

  public AddCondimentList(condimentList: MASCONDIMENTLIST) {
    return this.http.put<any>(`${this.apiURL}/condimentlist/insert`, condimentList);
  }

  public UpdateCondimentList(condimentList: MASCONDIMENTLIST) {
    return this.http.put<any>(`${this.apiURL}/condimentlist/update`, condimentList);
  }

  public DeleteCondimentList(condimentList: MASCONDIMENTLIST) {
    return this.http.put<any>(`${this.apiURL}/condimentlist/delete/`, condimentList);
  }

  //#endregion

  //#region condiment list price

  public GetCondimentListPrice() {
    return this.http.get<any>(`${this.apiURL}/condimentprice`);
  }

  public GetCondimentListPriceByCode(condimentCode: string) {
    return this.http.get<any>(`${this.apiURL}/condimentprice/${condimentCode}`);
  }

  public AddCondimentListPrice(condimentListPrice: MASCONDIMENTLISTPRICE) {
    return this.http.put<any>(`${this.apiURL}/condimentprice/insert`, condimentListPrice);
  }

  public UpdateCondimentListPrice(condimentListPrice: MASCONDIMENTLISTPRICE) {
    class CONDIMENTPRICE {
      M_CONDIMENT_CODE: string = "";
      M_PRICE_LEVEL: string = "";
      M_P_S1: number = 0;
      M_P_S2: number = 0;
      M_P_S3: number = 0;
      M_P_S4: number = 0;
      M_P_S5: number = 0;
      M_P_S6: number = 0;
      M_P_S7: number = 0;
      M_P_S8: number = 0;
      M_P_S9: number = 0;
      M_STATUS: string = "";
      M_USER_UPDATE: string = "";
      M_DATE_UPDATE: Date;
      M_DATE_INSERT: Date;
    }

    let condListPrice: CONDIMENTPRICE = new CONDIMENTPRICE();

    condListPrice.M_CONDIMENT_CODE = condimentListPrice.M_CONDIMENT_CODE;
    condListPrice.M_PRICE_LEVEL = condimentListPrice.M_PRICE_LEVEL;
    condListPrice.M_P_S1 = condimentListPrice.M_P_S1;
    condListPrice.M_P_S2 = condimentListPrice.M_P_S2;
    condListPrice.M_P_S3 = condimentListPrice.M_P_S3;
    condListPrice.M_P_S4 = condimentListPrice.M_P_S4;
    condListPrice.M_P_S5 = condimentListPrice.M_P_S5;
    condListPrice.M_P_S6 = condimentListPrice.M_P_S6;
    condListPrice.M_P_S7 = condimentListPrice.M_P_S7;
    condListPrice.M_P_S8 = condimentListPrice.M_P_S8;
    condListPrice.M_P_S9 = condimentListPrice.M_P_S9;
    condListPrice.M_STATUS = condimentListPrice.M_STATUS;
    condListPrice.M_USER_UPDATE = condimentListPrice.M_USER_UPDATE;
    condListPrice.M_DATE_UPDATE = condimentListPrice.M_DATE_UPDATE;
    condListPrice.M_DATE_INSERT = condimentListPrice.M_DATE_INSERT;

    return this.http.put<any>(`${this.apiURL}/condimentprice/update`, condListPrice);
  }

  public DeleteCondimentListPrice(condimentListPrice: MASCONDIMENTLISTPRICE) {
    return this.http.put<any>(`${this.apiURL}/condimentprice/delete/related`, condimentListPrice);
  }

  //#endregion

  //#region condiment group

  public GetCondimentGroup() {
    return this.http.get<any>(`${this.apiURL}/condimentgroup`);
  }

  public AddCondimentGroup(condimentGroup: MASCONDIMENTGROUP) {
    return this.http.put<any>(`${this.apiURL}/condimentgroup/insert`, condimentGroup);
  }

  public UpdateCondimentGroup(condimentGroup: MASCONDIMENTGROUP) {
    return this.http.put<any>(`${this.apiURL}/condimentgroup/update`, condimentGroup);
  }

  public DeleteCondimentGroup(condimentGroup: MASCONDIMENTGROUP) {
    return this.http.put<any>(`${this.apiURL}/condimentgroup/delete`, condimentGroup);
  }

  //#endregion

  //#region condiment group stock

  public GetCondimentGroupStock() {
    return this.http.get<any>(`${this.apiURL}/condimentstock`);
  }

  public GetCondimentGroupStockByGroupCode(groupCode: string) {
    return this.http.get<any>(`${this.apiURL}/condimentstock/${groupCode}`);
  }

  public AddCondimentGroupStock(condimentGroupStock: MASCONDIMENTGROUPSTOCK[]) {
    return this.http.put<any>(`${this.apiURL}/condimentstock/insert`, condimentGroupStock);
  }

  public UpdateCondimentGroupStock(condimentGroupStock: MASCONDIMENTGROUPSTOCK[]) {
    return this.http.put<any>(`${this.apiURL}/condimentstock/update`, condimentGroupStock);
  }

  public DeleteCondimentGroupStock(condimentGroupStock: MASCONDIMENTGROUPSTOCK[]) {
    return this.http.put<any>(`${this.apiURL}/condimentstock/delete`, condimentGroupStock);
  }

  //#endregion

  //#region tax

  public GetTax() {
    return this.http.get<any>(`${this.apiURL}/tax`);
  }

  public AddTax(tax: MASTAX) {
    return this.http.put<any>(`${this.apiURL}/tax/insert`, tax);
  }

  public UpdateTax(tax: MASTAX) {
    return this.http.put<any>(`${this.apiURL}/tax/update`, tax);
  }

  public DeleteTax(tax: MASTAX) {
    return this.http.put<any>(`${this.apiURL}/tax/delete`, tax);
  }

  public SetActiveTaxSystem(taxSystem: string) {

    return this.http.put<any>(`${this.apiURL}/tax/updateAction`, { M_TAX_SYSTEM: taxSystem });
  }

  //#endregion

  //#region Permission
  public getPermissionRights() {
    return this.http.get<any>(`${this.apiURL}/acl/permissions/grouped`);
  }

  public getPermissionByRole(role_id: string) {
    return this.http.get<any>(`${this.apiURL}/acl/permissions/grouped-role/${role_id}`);
  }

  public updatePermissionRights(formData: any) {
    return this.http.post<any>(`${this.apiURL}/acl/role/upsert-permission`, formData);
  }

  public deleteRole(role_id: any) {
    return this.http.delete<any>(`${this.apiURL}/acl/role/${role_id}?force=0`);
  }


  public removeRolesFromUser(formdata: any) {
    return this.http.post<any>(`${this.apiURL}/acl/user/remove-role`, formdata);
  }
  public assignRolesToUser(formdata: any) {
    return this.http.post<any>(`${this.apiURL}/acl/user/assign-role`, formdata);
  }
  public syncRolesToUser(formdata: any) {
    return this.http.post<any>(`${this.apiURL}/acl/user/upsert-role`, formdata);
  }

  //#endregion


  //#endregion

  //#region company profile/registration

  public GetRegistration() {
    return this.http.get<any>(`${this.apiURL}/registration`);
  }

  public AddRegistration(registration: TBLREGISTRATION) {
    return this.http.put<any>(`${this.apiURL}/registration/insert`, registration);
  }

  public UpdateRegistration(registration: TBLREGISTRATION) {
    return this.http.put<any>(`${this.apiURL}/registration/update`, registration);
  }

  public UploadRegistrationLogo(file: File) {
    const fd = new FormData();
    fd.append('T_LOGO', file, file.name);

    return this.http.post<any>(`${this.apiURL}/registration/insertImage`, fd);
  }

  //#endregion

  //#region 

  public GetSales() {
    return this.http.get<any>(`${this.apiURL}/sales`);
  }

  public GetSalesDtl() {
    return this.http.get<any>(`${this.apiURL}/salesdtl?limit=10`);
  }

  public salesummary(store: any,date:any) {
    const params = new HttpParams()
      .set('store_id', store)
      .set('date', date);

    return this.http.post<any>(`${this.apiURL}/salesummary`, {}, { params });
  }

  
  public paymentTypeGraph(store: any,date:any) {
    let payload = {
      store_id: store,
      date: date
    }

    return this.http.get<any>(`${this.apiURL}/paymentTypeGraphSummary`, { params: payload});
  }

  public topOutletGraph(limit: any,date:any) {
    let payload = {
      limit: limit,
      date: date
    }

    return this.http.get<any>(`${this.apiURL}/topStoreSalesSummary`, { params: payload});
  }

  //#endregion



  //log record//

  public AuditTrack(auditTrack: MASAUDITTRACK) {
    return this.http.put<any>(`${this.apiURL}/auditTrack/insert`, auditTrack);
  }

  public GetPaymentType() {
    return this.http.get<any>(`${this.apiURL}/bereport/getpaymenttype`);
  }

  public GetTerminal(ArrayStoreId: any) {
    let params = new HttpParams()
      .set('store_id', ArrayStoreId);

    return this.http.get<any>(`${this.apiURL}/bereport/getterminal`, { params });
  }

  public GetFilterDepartment(ArrayStoreId: any) {
    let params = new HttpParams()
      .set('group_id', ArrayStoreId);

    return this.http.get<any>(`${this.apiURL}/bereport/getdepartment`, { params });
  }

  public HourlySalesExport(datetype: any, store_id: any, terminal_id: any, groupingItem: any, startDate: any, endDate: any, file_type: string) {
 
    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('group_key', groupingItem);
 
 
    if (datetype === 'custom') {
      console.log('1');
      
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
 
    return this.http.get(`${this.apiURL}/bereport/hourlysalesreportjson`,{ params, observe: 'response', responseType: 'blob' });
  }

  public TaxTranscReport(datetype: any, store_id: any, terminal_id: any, sort_key: any, voids: any, startDate: any, endDate: any, file_type: string,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('sort_key', sort_key)
      .set('file_type', file_type)
      .set('void', voids);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/taxtransactionreport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public PaymentTypeAnalysisReport(datetype: any, store_id: any, terminal_id: any, payment_type: any, voids: any, shift: any, startDate: any, endDate: any, file_type: string ,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let payment = "";
    if (payment_type.length === 0) {
      payment = "";
    } else {
      payment = JSON.stringify(payment_type);
    }


    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('payment_type', payment)
      .set('void', voids)
      .set('file_type', file_type)
      .set('shift', shift);


    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/paymentanalysisreport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public TranxDetailsReport(datetype: any, store_id: any, terminal_id: any, sort_key: any, isTaxChecked: any, startDate: any, endDate: any, file_type: string,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('payment_type', isTaxChecked);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactiondetailanalysisreport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public ItemReport(startDate: any, endDate: any,sort_key: any,store_id: any, datetype: any,file_type: string, price_shift_id: any, price_level_id: any,stock_code_id: any,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let price_shift = "";
    if (price_shift_id.length === 0) {
      price_shift = "";
    } else {
      price_shift = JSON.stringify(price_shift_id);
    }

    let price_level = "";
    if (price_level_id.length === 0) {
      price_level = "";
    } else {
      price_level = JSON.stringify(price_level_id);
    }

    let stock_code = "";
    if (stock_code_id.length === 0) {
      stock_code = "";
    } else {
      stock_code = JSON.stringify(stock_code_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('price_shift', price_shift)
      .set('price_level', price_level)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('stock_code', stock_code)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    
    return this.http.get(`${this.apiURL}/bereport/itemreportbypricelevelshift`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  // public AverageSalesSummary(file_type: string, store_id: any, startDate: any, endDate: any,datetype: any,is_tax_included: any, sales_value: any, sort_key: any, callback: () => void) {

  //   let store = "";
  //   if (store_id.length === 0) {
  //     store = "";
  //   } else {
  //     store = JSON.stringify(store_id);
  //   }

  //   let params = new HttpParams()
  //     .set('datetype', datetype)
  //     .set('store_id', store)
  //     .set('file_type', file_type)
  //     .set('sales_value', sales_value)
  //     .set('sort_key', sort_key)
  //     .set('is_tax_included', is_tax_included);

  //   if (datetype === 'custom') {
  //     params = params.set('start_date', startDate)
  //       .set('end_date', endDate);
  //   }
    
  //   return this.http.get(`${this.apiURL}/bereport/averagesalessummary`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
  //     callback();
  //     this.checkReportResponseType(response);
  //   });
  // }
  public averageSalesSummaryExport(file_type: string, store_id: any, startDate: any, endDate: any,datetype: any,is_tax_included: any, sales_value: any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('file_type', file_type)
      .set('sales_value', sales_value)
      .set('is_tax_included', is_tax_included);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/averagesalessummary`,{ params, observe: 'response', responseType: 'blob' });
  }

  public OperatorCollection(file_type: string, store_id: any, startDate: any, endDate: any,datetype: any,operator_id: any,  callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }

    let operator = "";
    if (operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('file_type', file_type)
      .set('operator_id', operator);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/operatorcollection`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public StoreVoucherReport(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, operator_id: any, sort_key: any, terminal_id: any, shift_id: any,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let shift = "";
    if (shift_id.length === 0) {
      shift = "";
    } else {
      shift = JSON.stringify(shift_id);
    }
    let operator = "";
    if (operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('operator_id', operator)
      .set('shift_id', shift);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/storevoucher`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public VendorVoucherReport(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, operator_id: any, sort_key: any, terminal_id: any, stock_id: any, group_id:any, department_id:any, category_id:any, shift_id: any,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let shift = "";
    if (shift_id.length === 0) {
      shift = "";
    } else {
      shift = JSON.stringify(shift_id);
    }
    let operator = "";
    if (operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }
    let stock = "";
    if (stock_id.length === 0) {
      stock = "";
    } else {
      stock = JSON.stringify(stock_id);
    }
    let group = "";
    if (group_id.length === 0) {
      group = "";
    } else {
      group = JSON.stringify(group_id);
    }
    let department = "";
    if (department_id.length === 0) {
      department = "";
    } else {
      department = JSON.stringify(department_id);
    }
    let category = "";
    if (category_id.length === 0) {
      category = "";
    } else {
      category = JSON.stringify(category_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('operator_id', operator)
      .set('stock_id', stock)
      .set('group_id', group)
      .set('department_id', department)
      .set('category_id', category)
      .set('shift_id', shift);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/vendorvoucher`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public SoldItem(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, price:any, item:any, foc:any, discount:any, transaction_void:any, combine_void:any, normal_sales:any, operator_id:any, terminal_id: any, stock_id: any, group_id:any, department_id:any, category_id:any, callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let operator = "";
    if (operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }
    let stock = "";
    if (stock_id.length === 0) {
      stock = "";
    } else {
      stock = JSON.stringify(stock_id);
    }
    let group = "";
    if (group_id.length === 0) {
      group = "";
    } else {
      group = JSON.stringify(group_id);
    }
    let department = "";
    if (department_id.length === 0) {
      department = "";
    } else {
      department = JSON.stringify(department_id);
    }
    let category = "";
    if (category_id.length === 0) {
      category = "";
    } else {
      category = JSON.stringify(category_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('price', price)
      .set('item', item)
      .set('foc', foc)
      .set('discount', discount)
      .set('transaction_void', transaction_void)
      .set('combine_void', combine_void)
      .set('normal_sales', normal_sales)
      .set('operator_id', operator)
      .set('stock_id', stock)
      .set('group_id', group)
      .set('department_id', department)
      .set('category_id', category)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/solditemanalysis`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public ReceiptAnalysis(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, sort_key:any, terminal_id: any, transaction_void:any, combine_void:any, normal_sales:any, remark_not_null:any, callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('transaction_void', transaction_void)
      .set('combine_void', combine_void)
      .set('normal_sales', normal_sales)
      .set('remark_not_null', remark_not_null)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/receiptanalysis`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public SalesRemark(startDate: any, endDate: any,sort_key:any, store_id: any, datetype: any, file_type: string, terminal_id: any, transaction_void:any, callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('transaction_void', transaction_void)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    
    return this.http.get(`${this.apiURL}/bereport/salesremark`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public TerminalCollectionReport(datetype: any, store_id: any, terminal_id: any, sort_key: any, startDate: any, endDate: any, payment_type: any, file_type: string,callback: () => void) {

    let store = "";
    if (store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let payment = "";
    if (payment_type.length === 0) {
      payment = "";
    } else {
      payment = JSON.stringify(payment_type);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('sort_key', sort_key)
      .set('store_id', store)
      .set('file_type', file_type)
      .set('terminal_id', terminal)
      .set('payment_type', payment);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/terminalcollectionreport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public CaterogrySalesReport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/categorysalesresport`, { params, observe: 'response', responseType: 'blob' }).subscribe(
      (response) => {
        callback();
        this.checkReportResponseType(response);
      }
    );
  }

  public DepartmentSalesReport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/departmentsalesresport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public GroupSalesReport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/groupsalesresport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }
  public SKUSalesReport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/skusalesresport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }
  public TransactionSalesReport(file_type: string, storeId: any,startDate: any, endDate: any, datetype: any,  callback: () => void) {
    // let store = JSON.stringify(storeId);
    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactionsalesresport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }
  public TransactionVoidReport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactionvoidreport`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public InactiveStockReport(sort_key: any, file_type: string,callback: () => void) {

    let params = new HttpParams()
    .set('file_type', file_type)
    .set('sort_key', sort_key)

    return this.http.get(`${this.apiURL}/bereport/inactivestocklisting`, { params, observe: 'response', responseType: 'blob' }).subscribe((response) => {
      callback();
      this.checkReportResponseType(response);
    });
  }

  public getTopList(StoreandDate: any) {
    const params = new HttpParams()
      .set('store_id', StoreandDate.storeFilter)
      .set('date', StoreandDate.timeFilter.selectionVal)
      .set('limit', StoreandDate.count);

    return this.http.post<any>(`${this.apiURL}/topcontribution`, {}, { params });
  }

  public getTopListItem(StoreandDate: any) {
    const params = new HttpParams()
      .set('store_id', StoreandDate.storeFilter)
      .set('date', StoreandDate.timeFilter.selectionVal)
      .set('limit', StoreandDate.count);

    return this.http.post<any>(`${this.apiURL}/topitem`, {}, { params });
  }

  //#kitchenprinting 

  public GetSpoolerList() {
    return this.http.get<any>(`${this.apiURL}/spooler/index`);
  }

  public EditSpoolerList(id: any) {
    return this.http.get<any>(`${this.apiURL}/spooler/edit?spooler_id=${id}`);
  }

  public GetPrinterList(spoolerID: any) {
    return this.http.post<any>(`${this.apiURL}/printer/index?spooler_id=${spoolerID}`, null);
  }

  public EditPrinterList(spoolerID: any, printerID: any) {
    return this.http.post<any>(`${this.apiURL}/printer/edit?spooler_id=${spoolerID}&printer_id=${printerID}`, null);
  }

  public updatePrinter(data: any) {
    return this.http.post<any>(`${this.apiURL}/printer/update`, data);
  }

  public GetQueueList() {
    return this.http.get<any>(`${this.apiURL}/queue/index`);
  }

  public deleteQueue(id: any) {
    return this.http.post<any>(`${this.apiURL}/queue/delete?queue_code=${id}`, null);
  }

  public StoreQueue(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/store`, data);
  }

  public getPrinterBySpoolerID(data: any) {
    return this.http.get<any>(`${this.apiURL}/queue/getprinter?spooler_id=${data.spooler_id}&queue_code=${data.queue_code}`);
  }

  public filterByPrinterAndSpooler(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/addprinter`, data);
  }

  public getQueueLinkList() {
    return this.http.get<any>(`${this.apiURL}/queue/queuelink`);
  }

  public getQueueLink(id: any) {
    return this.http.get<any>(`${this.apiURL}/queue/getqueuelink?queue_id=${id}`);
  }

  public storeQueueLink(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/storequeuelink`, data);
  }

  public deleteQueueLink(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/deletequeuelink?queue_code=${data.queue_code}&department_code=${data.department_code}`, null);
  }

  public deleteSpoolerPrinterFromQueue(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/deleteprinter?spooler_id=${data.spooler_id}&printer_id=${data.printer_id}&queue_code=${data.queue_code}`, null);
  }

  public getPrinterDetail(data: any) {
    return this.http.post<any>(`${this.apiURL}/printer/edit?spooler_id=${data.spooler_id}&printer_id=${data.printer_id}`, null);
  }

  public updateQueue(data: any) {
    return this.http.post<any>(`${this.apiURL}/queue/update`, data);
  }

  public getQueueDetail(id: any) {
    return this.http.get<any>(`${this.apiURL}/queue/edit?queue_code=${id}`);
  }

  public stockItemGetQueueList(id: any) {
    return this.http.get<any>(`${this.apiURL}/stockqueue/getqueuelist?stock_id=${id}`);
  }

  public stockItemGetQueue(id: any) {
    return this.http.get<any>(`${this.apiURL}/stockqueue?stock_id=${id}`);
  }

  public storeStockItemQueue(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockqueue/insert`, data);
  }

  public deleteStockItemQueue(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockqueue/delete`, data);
  }

  //#crm
  public setCRMurl(data: any) {
    return this.http.post<any>(`${this.apiURL}/settings/update`, data);
  }

  public editCRMurl(data: any) {
    return this.http.get<any>(`${this.apiURL}/settings/edit?name=${data}`, data);
  }

  //#endkitchenprinting

  downloadFile(response: any, fileName?: string) {
    saveAs(response.body)
  }

  dialogOpen() {
    this.messageDialog.open(MessageDialogComponent, {
      data:
      {
        title: 'Error',
        message: "Data Not Found"
      }
    });
  }

  checkReportResponseType(response:any){
    
    const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        this.dialogOpen();
      } else {
        // If the response content type is not JSON, response.body is a Blob
        this.downloadFile(response);
      }
  }

  public getAllNMStockItem() {
    return this.http.get<any>(`${this.apiURL}/stock/getsetmenu`);
  }

  public getLineGrouphSummary(id:any,date:any,type:any)
  {
    const params = new HttpParams()
    .set('store_id', id)
    .set('date', date)
    .set('type', type);

    return this.http.get<any>(`${this.apiURL}/getLineGraphSummary`, { params });
  }

  //STOCK IN
  public STOCK_IN_EDIT(data: string) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);


    return this.http.get<any>(`${this.apiURL}/stockin/edit`,{ params });
  }

  public STOCK_IN_GETLIST(item:number,page:number,searchResult:string) {
    const params = new HttpParams()
    .set('page', page)
    .set('item', item)
    .set('search', searchResult);
    return this.http.get<any>(`${this.apiURL}/stockin`,{ params });
  }

  public STOCK_IN_ALLITEM(data:any) {

    return this.http.post<any>(`${this.apiURL}/stockin/getstock`,data);
  }

  public STOCK_IN_ITEM_LIST(data:any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/stockin/getstockdetail`,{params});
  }

  public STOCK_IN_INSERT(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockin/store`, data);
  }

  public STOCK_IN_UPDATE(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockin/update`, data);
  }

  //STOCK OUT
  public STOCK_OUT_EDIT(data: string) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);


    return this.http.get<any>(`${this.apiURL}/stockout/edit`,{ params });
  }

  public STOCK_OUT_GETLIST(item:number,page:number,searchResult:string) {
    const params = new HttpParams()
    .set('page', page)
    .set('item', item)
    .set('search', searchResult);
    return this.http.get<any>(`${this.apiURL}/stockout`,{ params });
  }

  public STOCK_OUT_ALLITEM(data:any) {
    
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/stockout/getstock`);
  }

  public STOCK_OUT_ITEM_LIST(data:any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/stockout/getstockdetail`,{params});
  }

  public STOCK_OUT_INSERT(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockout/store`, data);
  }

  public STOCK_OUT_UPDATE(data: any) {
    return this.http.post<any>(`${this.apiURL}/stockout/update`, data);
  }

  //COST ADJUSTMENT
  public COST_ADJ_LIST(item:number,page:number,searchResult:string) {
    const params = new HttpParams()
    .set('page', page)
    .set('item', item)
    .set('search', searchResult);
    return this.http.get<any>(`${this.apiURL}/costadjustment`,{ params });
  }

  public COST_ADJ_EDIT(data:any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/costadjustment/edit`,{params});
  }

  public COST_ADJ_ALL_ITEM() {
    return this.http.get<any>(`${this.apiURL}/costadjustment/getstock`);
  }

  public COST_ADJ_INSERT(data:any) {

    return this.http.post<any>(`${this.apiURL}/costadjustment/store`,data);
  }

  public COST_ADJ_UPDATE(data: any) {
    return this.http.post<any>(`${this.apiURL}/costadjustment/update`, data);
  }

  public COST_ADJ_ITEMLIST(data: any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/costadjustment/getstockdetail`,{params});
  }


  //QTY ADJUSTMENT
  public QTY_ADJ_LIST(item:number,page:number,searchResult:string) {
    const params = new HttpParams()
    .set('page', page)
    .set('item', item)
    .set('search', searchResult);
    return this.http.get<any>(`${this.apiURL}/qtyadjustment`,{ params });
  }

  public QTY_ADJ_EDIT(data:any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/qtyadjustment/edit`,{params});
  }

  public QTY_ADJ_ALL_ITEM() {
    return this.http.get<any>(`${this.apiURL}/qtyadjustment/getstock`);
  }

  public QTY_ADJ_INSERT(data:any) {

    return this.http.post<any>(`${this.apiURL}/qtyadjustment/store`,data);
  }

  public QTY_ADJ_UPDATE(data: any) {
    return this.http.post<any>(`${this.apiURL}/qtyadjustment/update`, data);
  }

  public QTY_ADJ_ITEMLIST(data: any) {
    const params = new HttpParams()
    .set('S_DOC_ID', data);

    return this.http.get<any>(`${this.apiURL}/qtyadjustment/getstockdetail`,{params});
  }

  //EXPORT  
  public EXPORT_STOCKIN(data: any) {
    const params = new HttpParams()
    .set('search', data);

    return this.http.get<any>(`${this.apiURL}/stockin/export`,{params});
  }

  public EXPORT_STOCKOUT(data: any) {
    const params = new HttpParams()
    .set('search', data);

    return this.http.get<any>(`${this.apiURL}/stockout/export`,{params});
  }

  public EXPORT_COSTADJ(data: any) {
    const params = new HttpParams()
    .set('search', data);

    return this.http.get<any>(`${this.apiURL}/costadjustment/export`,{params});
  }

  public EXPORT_QTYADJ(data: any) {
    const params = new HttpParams()
    .set('search', data);

    return this.http.get<any>(`${this.apiURL}/qtyadjustment/export`,{params});
  }

  //FILTER
  public GetFilterShift() {
    return this.http.get<any>(`${this.apiURL}/bereport/getshift`);
  }

  public GetFilterOperator() {
    return this.http.get<any>(`${this.apiURL}/bereport/getuser`);
  }

  public GetFilterStores() {
    return this.http.get<any>(`${this.apiURL}/bereport/getstore`);
  }

  public GetFilterGroup() {
    return this.http.get<any>(`${this.apiURL}/bereport/getgroup`);
  }

  public GetFilterCategory() {
    return this.http.get<any>(`${this.apiURL}/bereport/getcategory`);
  }

  public GetFilterPriceLevel() {
    return this.http.get<any>(`${this.apiURL}/bereport/getpricelevel`);
  }

  public GetFilterPriceShift() {
    return this.http.get<any>(`${this.apiURL}/bereport/getpriceshift`);
  }

  public GetFilterStockCode() {
    return this.http.get<any>(`${this.apiURL}/bereport/getstock`);
  }

  // Reset

  public ResetData(data:any, type: string) {

    let apiUrl = `${this.apiURL}/sales/delete`;

    if (type == "attendance"){
      apiUrl = `${this.apiURL}/time-attendance/delete`;
    }
    
    return this.http.put<any>(`${apiUrl}`, data);
  }


  //preview
  getTerminal(storeId: any) {
    const url = `${this.apiURL}/bereport/getterminal?store_id=${storeId}`;
    return this.http.get<any>(url);
  }

  hourlySales(
    fileType: string,
    start: string,
    end: string,
    groupId: string,
    storeId: string,
    terminalId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/hourlysalesreportjson?start_date=${start}&end_date=${end}&terminal_id=${terminalId}&store_id=${storeId}&group_key=${groupId}&datetype=${dateType}&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  itemreportbypricelevelshift(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    priceId: string,
    stockId: string,
    shiftId: string,
    dateType: any,
    sortKey:any,
    group_by: any
  ) {
    const url = `${this.apiURL}/bereport/itemreportbypricelevelshift?start_date=${start}&end_date=${end}&sort_key=${sortKey}&store_id=${storeId}&datetype=${dateType}&file_type=${fileType}&price_shift=${shiftId}&price_level=${priceId}&stock_code=${stockId}&group_by=${group_by}`;
    return this.http.get<any>(url);
  }

  
  public ItemExport(data: {startDate: any, endDate: any,sort_key: any,store_id: any, datetype: any,file_type: string, price_shift_id: any, price_level_id: any,stock_code_id: any, sortKey:any, group_by: string}) {

    let store = "";
    if (data?.store_id === undefined || data?.store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(data?.store_id);
    }
    let price_shift = "";
    if (data?.price_shift_id === undefined || data?.price_shift_id.length === 0) {
      price_shift = "";
    } else {
      price_shift = JSON.stringify(data?.price_shift_id);
    }

    let price_level = "";
    if (data?.price_level_id === undefined || data?.price_level_id.length === 0) {
      price_level = "";
    } else {
      price_level = JSON.stringify(data?.price_level_id);
    }

    let stock_code = "";
    if (data?.stock_code_id === undefined || data?.stock_code_id.length === 0) {
      stock_code = "";
    } else {
      stock_code = JSON.stringify(data?.stock_code_id);
    }

    let params = new HttpParams()
      .set('datetype', data?.datetype)
      .set('store_id', store)
      .set('price_shift', price_shift)
      .set('price_level', price_level)
      .set('file_type', data?.file_type)
      .set('sort_key', data?.sort_key)
      .set('stock_code', stock_code)
      .set('sort_key', data?.sortKey)
      .set('group_by', data?.group_by)

    if (data?.datetype === 'custom') {
      params = params.set('start_date', data?.startDate)
        .set('end_date', data?.endDate);
    }
    console.log('params', params);
    
    return this.http.get(`${this.apiURL}/bereport/itemreportbypricelevelshift`,{ params, observe: 'response', responseType: 'blob' });
  }
  
  terminalCollection(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    paymentId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/terminalcollectionreport?start_date=${start}&end_date=${end}&terminal_id=${terminalId}&store_id=${storeId}&payment_type=${paymentId}&sort_key=PYMT_CLOSEDATE&datetype=${dateType}&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  public TerminalCollectionExport(datetype: any, store_id: any, terminal_id: any, sort_key: any, startDate: any, endDate: any, payment_type: any, file_type: string) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let payment = "";
    if (payment_type === undefined || payment_type.length === 0) {
      payment = "";
    } else {
      payment = JSON.stringify(payment_type);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('sort_key', sort_key)
      .set('store_id', store)
      .set('file_type', file_type)
      .set('terminal_id', terminal)
      .set('payment_type', payment);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/terminalcollectionreport`,{ params, observe: 'response', responseType: 'blob' });
  }
  salesRemark(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    checkbox: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/salesremark?start_date=${start}&end_date=${end}&sort_key=SALES_REMARK1&store_id=${storeId}&datetype=${dateType}&file_type=${fileType}&terminal_id=${terminalId}&void=${checkbox}`;
    return this.http.get<any>(url);
  }

  public SalesRemarkExport(startDate: any, endDate: any,sort_key:any, store_id: any, datetype: any, file_type: string, terminal_id: any, transaction_void:any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('void', transaction_void)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    console.log('params', params);
    
    return this.http.get(`${this.apiURL}/bereport/salesremark`,{ params, observe: 'response', responseType: 'blob' });
  }

  soldItemAnalysis(
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    groupId: string,
    departmentId: string,
    categoryId: string,
    stockId: string,
    checkbox: string,
    checkboxShift: string,
    checkboxChanged: string,
    checkboxDiscount: string,
    checkboxTransaction: string,
    checkboxCombine: string,
    checkboxNormal: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/solditemanalysis?file_type=json&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}&price=${checkbox}&item=${checkboxShift}&foc=${checkboxChanged}&discount=${checkboxDiscount}&void=${checkboxTransaction}&combine_void=${checkboxCombine}&normal_sales=${checkboxNormal}&terminal_id=${terminalId}&stock_code=${stockId}&group=${groupId}&department=${departmentId}&category=${categoryId}`;
    return this.http.get<any>(url);
  }

  public SoldItemExport(data: {file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, price:any, item:any, foc:any, discount:any, transaction_void:any, combine_void:any, normal_sales:any, terminal_id: any, stock_id: any, group_id:any, department_id:any, category_id:any}) {

    let store = "";
    if (data?.store_id === undefined || data?.store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(data?.store_id);
    }
    let terminal = "";
    if (data?.terminal_id === undefined || data?.terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(data?.terminal_id);
    }
    let stock = "";
    if (data?.stock_id === undefined || data?.stock_id.length === 0) {
      stock = "";
    } else {
      stock = JSON.stringify(data?.stock_id);
    }
    let group = "";
    if (data?.group_id === undefined || data?.group_id.length === 0) {
      group = "";
    } else {
      group = JSON.stringify(data?.group_id);
    }
    let department = "";
    if (data?.department_id === undefined || data?.department_id.length === 0) {
      department = "";
    } else {
      department = JSON.stringify(data?.department_id);
    }
    let category = "";
    if (data?.category_id === undefined || data?.category_id.length === 0) {
      category = "";
    } else {
      category = JSON.stringify(data?.category_id);
    }

    let params = new HttpParams()
      .set('datetype', data?.datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', data?.file_type)
      .set('price', data?.price)
      .set('item', data?.item)
      .set('foc', data?.foc)
      .set('discount', data?.discount)
      .set('void', data?.transaction_void)
      .set('combine_void', data?.combine_void)
      .set('normal_sales', data?.normal_sales)
      .set('stock_id', stock)
      .set('group_id', group)
      .set('department_id', department)
      .set('category_id', category)

    if (data?.datetype === 'custom') {
      params = params.set('start_date', data?.startDate)
        .set('end_date', data?.endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/solditemanalysis`,{ params, observe: 'response', responseType: 'blob' });
  }
  
  operatorCollection(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    operatorId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/operatorcollection?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}&operation_id=${operatorId}`;
    return this.http.get<any>(url);
  }

  public OperatorCollectionExport(file_type: string, store_id: any, startDate: any, endDate: any,datetype: any,operation_id: any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }

    let operator = "";
    if (operation_id === undefined || operation_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operation_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('file_type', file_type)
      .set('operation_id', operator);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/operatorcollection`,{ params, observe: 'response', responseType: 'blob' });
  }
  averageSalesSummary(
    fileType: string,
    start: string,
    end: string,
    storeIdValue: any,
    salesId: any,
    checked: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/averagesalessummary?file_type=${fileType}&store_id=${storeIdValue}&start_date=${start}&end_date=${end}&datetype=${dateType}&is_tax_included=${checked}&sales_value=${salesId}`;
    return this.http.get<any>(url);
  }
  transactionDetail(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    sort:any,
    checkbox: string,
    dateType: any,
  ) {
    const url = `${this.apiURL}/bereport/transactiondetailanalysisreport?start_date=${start}&end_date=${end}&is_tax_include=${checkbox}&terminal_id=${terminalId}&sort_key=${sort}&store_id=${storeId}&datetype=${dateType}&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  public TranxDetailsExport(datetype: any, store_id: any, terminal_id: any, sort_key: any, isTaxChecked: any,startDate:any,endDate:any, file_type: string) {

    console.log(store_id)
    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }

    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('payment_type', isTaxChecked);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactiondetailanalysisreport`, { params, observe: 'response', responseType: 'blob' });
  }
  paymentType(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    paymentId: string,
    checkbox: string,
    checkboxShift: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/paymentanalysisreport?start_date=${start}&end_date=${end}&store_id=${storeId}&terminal_id=${terminalId}&payment_type=${paymentId}&void=${checkbox}&shift=${checkboxShift}&datetype=${dateType}&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  public PaymentTypeAnalysisExport(datetype: any, store_id: any, terminal_id: any, payment_type: any, voids: any, shift: any,startDate:any,endDate:any, file_type: string) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let payment = "";
    if (payment_type === undefined || payment_type.length === 0) {
      payment = "";
    } else {
      payment = JSON.stringify(payment_type);
    }


    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('payment_type', payment)
      .set('void', voids)
      .set('file_type', file_type)
      .set('shift', shift);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/paymentanalysisreport`,{ params, observe: 'response', responseType: 'blob' });
  }
  inactiveStock(fileType: string) {
    const url = `${this.apiURL}/bereport/inactivestocklisting?sort_key=M_STOCK_CODE&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  public InactiveStockExport(sort_key: any, file_type: string) {

    let params = new HttpParams()
    .set('file_type', file_type)
    .set('sort_key', sort_key)

    return this.http.get(`${this.apiURL}/bereport/inactivestocklisting`,{ params, observe: 'response', responseType: 'blob' });
  }
  categorySales(
    fileType: string,
    start: string,
    end: string,
    storeId: any,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/categorysalesresport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public categorySalesExport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string) {
    console.log('startDate', startDate);
    console.log('endDate', endDate);
    
    let params = new HttpParams()
        .set('datetype', datetype)
        .set('file_type', file_type)
        .set('store_id', storeId);

    if (datetype === 'custom') {
        console.log('1');
        
        params = params
            .set('start_date', startDate)
            .set('end_date', endDate);
    }
    console.log('params', params);
    
    return this.http.get(`${this.apiURL}/bereport/categorysalesresport`, { params, observe: 'response', responseType: 'blob' });
}

  storeVoucher(
    fileType: string,
    start: string,
    end: string,
    storeId: any,
    terminal: any,
    shift: any,
    operator: any,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/storevoucher?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}&operator_id=${operator}&sort_key=SALES_CLOSEDATE&terminal_id=${terminal}&shift_id=${shift}`;
    return this.http.get<any>(url);
  }

  public StoreVoucherExport(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, operator_id: any, sort_key: any, terminal_id: any, shift_id: any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let shift = "";
    if (shift_id === undefined || shift_id.length === 0) {
      shift = "";
    } else {
      shift = JSON.stringify(shift_id);
    }
    let operator = "";
    if (operator_id === undefined || operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('operator_id', operator)
      .set('shift_id', shift);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/storevoucher`,{ params, observe: 'response', responseType: 'blob' });
  }
  vendorVoucher(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    groupId: string,
    departmentId: string,
    shiftId: string,
    operatorId: string,
    categoryId: string,
    stockId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/vendorvoucher?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}&operator_id=${operatorId}&sort_key=SDTL_CLOSEDATE&terminal_id=${terminalId}&stock_id=${stockId}&group_id=${groupId}&department_id=${departmentId}&category_id=${categoryId}&shift_id=${shiftId}`;
    return this.http.get<any>(url);
  }

  public VendorVoucherExport(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, operator_id: any, sort_key: any, terminal_id: any, stock_id: any, group_id:any, department_id:any, category_id:any, shift_id: any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }
    let shift = "";
    if (shift_id === undefined || shift_id.length === 0) {
      shift = "";
    } else {
      shift = JSON.stringify(shift_id);
    }
    let operator = "";
    if (operator_id === undefined || operator_id.length === 0) {
      operator = "";
    } else {
      operator = JSON.stringify(operator_id);
    }
    let stock = "";
    if (stock_id === undefined || stock_id.length === 0) {
      stock = "";
    } else {
      stock = JSON.stringify(stock_id);
    }
    let group = "";
    if (group_id === undefined || group_id.length === 0) {
      group = "";
    } else {
      group = JSON.stringify(group_id);
    }
    let department = "";
    if (department_id === undefined || department_id.length === 0) {
      department = "";
    } else {
      department = JSON.stringify(department_id);
    }
    let category = "";
    if (category_id === undefined || category_id.length === 0) {
      category = "";
    } else {
      category = JSON.stringify(category_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('operator_id', operator)
      .set('stock_id', stock)
      .set('group_id', group)
      .set('department_id', department)
      .set('category_id', category)
      .set('shift_id', shift);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/vendorvoucher`,{ params, observe: 'response', responseType: 'blob' });
  }

  receiptAnalysis(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    checkbox: string,
    combine: string,
    normal: string,
    remark: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/receiptanalysis?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}&sort_key=SALES_CLOSEDATE&terminal_id=${terminalId}&void=${checkbox}&combine_void=${combine}&normal_sales=${normal}&remark_not_null=${remark}`;
    return this.http.get<any>(url);
  }

  public ReceiptAnalysisExport(file_type: string, store_id: any,startDate: any, endDate: any, datetype: any, sort_key:any, terminal_id: any, transaction_void:any, combine_void:any, normal_sales:any, remark_not_null:any) {

    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('file_type', file_type)
      .set('sort_key', sort_key)
      .set('void', transaction_void)
      .set('combine_void', combine_void)
      .set('normal_sales', normal_sales)
      .set('remark_not_null', remark_not_null)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }
    
    return this.http.get(`${this.apiURL}/bereport/receiptanalysis`,{ params, observe: 'response', responseType: 'blob' });
  }
  skuSales(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/skusalesresport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public SKUSalesExport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/skusalesresport`,{ params, observe: 'response', responseType: 'blob' });
  }
  groupSales(
    fileType: string,
    start: string,
    end: string,
    storeId: any,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/groupsalesresport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public GroupSalesExport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/groupsalesresport`,{ params, observe: 'response', responseType: 'blob' });
  }
  transactionVoid(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/transactionvoidreport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public TransactionVoidExport(datetype: any, startDate: any, endDate: any, storeId: any, file_type: string) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactionvoidreport`,{ params, observe: 'response', responseType: 'blob' });
  }
  transactionSales(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/transactionsalesresport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public TransactionSalesExport(file_type: string, storeId: any,startDate: any, endDate: any, datetype: any) {
    // let store = JSON.stringify(storeId);
    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/transactionsalesresport`,{ params, observe: 'response', responseType: 'blob' });
  }
  departmentSales(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/departmentsalesresport?file_type=${fileType}&store_id=${storeId}&start_date=${start}&end_date=${end}&datetype=${dateType}`;
    return this.http.get<any>(url);
  }

  public DepartmentSalesExport(file_type: string, startDate: any, endDate: any, storeId: any,datetype: any) {

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('file_type', file_type)
      .set('store_id', storeId)

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/departmentsalesresport`,{ params, observe: 'response', responseType: 'blob' });
  }

  taxTransaction(
    fileType: string,
    start: string,
    end: string,
    storeId: string,
    terminalId: string,
    checkbox: string,
    dateType: any
  ) {
    const url = `${this.apiURL}/bereport/taxtransactionreport?start_date=${start}&end_date=${end}&void=${checkbox}&sort_key=SALES_CTRNO&store_id=${storeId}&terminal_id=${terminalId}&datetype=${dateType}&file_type=${fileType}`;
    return this.http.get<any>(url);
  }

  public TaxTranscExport(datetype: any, store_id: any, terminal_id: any, sort_key: any, voids: any, startDate: any, endDate: any, file_type: string) {
    // let sort = "SALES_CTRNO";
    let store = "";
    if (store_id === undefined || store_id.length === 0) {
      store = "";
    } else {
      store = JSON.stringify(store_id);
    }
    let terminal = "";
    if (terminal_id === undefined || terminal_id.length === 0) {
      terminal = "";
    } else {
      terminal = JSON.stringify(terminal_id);
    }

    let params = new HttpParams()
      .set('datetype', datetype)
      .set('store_id', store)
      .set('terminal_id', terminal)
      .set('sort_key', sort_key)
      .set('file_type', file_type)
      .set('void', voids);

    if (datetype === 'custom') {
      params = params.set('start_date', startDate)
        .set('end_date', endDate);
    }

    return this.http.get(`${this.apiURL}/bereport/taxtransactionreport`,{ params, observe: 'response', responseType: 'blob' });
  }


  //#region Customer
  

  public getDiscountTypeList(is_active?: boolean){
    let urlParam = "?";
    if (is_active){
      urlParam += "M_STATUS=ACTIVE";
    }
    return this.http.get<any>(`${this.apiURL}/discount-type${urlParam}&sort_by=M_CODE&sort_order=ASC&paginate=false`);
  }

  public updateDiscountType(dicountData: any[]){
    return this.http.post<any>(`${this.apiURL}/discount-type/upsert`, dicountData);
  }

  public insertDiscountType(dicountData: any[]){
    return this.http.post<any>(`${this.apiURL}/discount-type/insert`, dicountData);
  }

  public getDiscountType(M_CODE: string){
    return this.http.get<any>(`${this.apiURL}/discount-type/${M_CODE}`);
  }

  
  public getCustomerGroupList(is_active?: boolean){
    let urlParam = "?";
    if (is_active){
      urlParam += "M_ACTIVE=T";
    }
    return this.http.get<any>(`${this.apiURL}/customer-group${urlParam}&sort_by=M_CODE&sort_order=ASC&paginate=false`);
  }

  public getCustomerGroup(M_CODE: string){
    return this.http.get<any>(`${this.apiURL}/customer-group/${M_CODE}`);
  }
  
  public updateCustomerGroup(groupData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer-group/upsert`, groupData);
  }

  public insertCustomerGroup(groupData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer-group/insert`, groupData);
  }

  
  public getCustomerClassList(is_active?: boolean){
    let urlParam = "?";
    if (is_active){
      urlParam += "M_STATUS=ACTIVE";
    }
    return this.http.get<any>(`${this.apiURL}/customer-class${urlParam}&sort_by=M_CODE&sort_order=ASC&paginate=false`);
  }

  public updateCustomerClass(classData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer-class/upsert`, classData);
  }

  public insertCustomerClass(classData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer-class/insert`, classData);
  }

  public getCustomerClass(M_CODE: string){
    return this.http.get<any>(`${this.apiURL}/customer-class/${M_CODE}`);
  }

  
  public getCustomerList(){
    return this.http.get<any>(`${this.apiURL}/customer?paginate=false`);
  }

  public getCustomerDetails(M_CODE: string){
    return this.http.get<any>(`${this.apiURL}/customer/${M_CODE}`);
  }

  public updateCustomerDetails(detailsData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer/upsert`, detailsData);
  }

  public insertCustomerDetails(detailsData: any[]){
    return this.http.post<any>(`${this.apiURL}/customer/insert`, detailsData);
  }

  
  public getClosingList(){
    return this.http.get<any>(`${this.apiURL}/period-close?paginate=false&sort_order=ASC`);
  }

  public insertCustomerClosing(data: any[]){
    return this.http.post<any>(`${this.apiURL}/period-close/insert`, data);
  }

  
  public getCustomerListWithFilter(groupFrom: string, groupTo: string, classFrom: string, classTo: string){
    let param = "";
    if (groupFrom != "" && groupFrom != null){
      param = param + `&M_CUSTOMER_GROUP_FROM=${groupFrom}`;
    }
    if (groupTo != "" && groupTo != null){
      param = param + `&M_CUSTOMER_GROUP_TO=${groupTo}`;
    }
    if (classFrom != "" && classFrom != null){
      param = param + `&M_CUSTOMER_CLASS_FROM=${classFrom}`;
    }
    if (classTo != "" && classTo != null){
      param = param + `&M_CUSTOMER_CLASS_TO=${classTo}`;
    }

    return this.http.get<any>(`${this.apiURL}/customer?paginate=false${param}`);
  }

  
  public getCreditAdjustmentLog(M_CODE: string, filterBy: string){

    let tempFilter = "";
    if (filterBy != null && filterBy != ""){
      tempFilter = `&type=${filterBy}`
    }

    return this.http.get<any>(`${this.apiURL}/ar-credit-adj-log?paginate=false&S_CODE=${M_CODE}${tempFilter}`);
  }

  
  public insertCreditAdjustment(data: any[]){
    return this.http.post<any>(`${this.apiURL}/ar-credit-adj-log/insert`, data);
  }

  
  public getCustomerBalanceByCode(M_CODE:string){
    return this.http.get<any>(`${this.apiURL}/customer-bal/${M_CODE}`);
  }

  public getCustomerLogByFilter(M_CODE:string, CB_CLOSEDATE: string){

    let tempString = "";
    if (CB_CLOSEDATE != null){
      tempString = `&CB_CLOSEDATE=${CB_CLOSEDATE}`;
    }
    return this.http.get<any>(`${this.apiURL}/customer-log?paginate=false&CB_CODE=${M_CODE}${tempString}`);
  }

  //#endregion

  //#region E-Receipt
  
  public getReceiptData(receipt_no:string, version: string){
    return this.http.get(`${this.apiURL}/e-receipt/view?receipt_no=${receipt_no}&v=${version}`,{ observe: 'response', responseType: 'text' });
  }

  public downloadReceipt(receipt_no:string){
    return this.http.get(`${this.apiURL}/e-receipt/pdf?receipt_no=${receipt_no}`,{ responseType: 'blob' });
  }

  
  public emailReceipt(formData: any){
    return this.http.post<any>(`${this.apiURL}/e-receipt/email`, formData);
  }

  public getEReceiptSetting(storeCode: any){
    return this.http.get<any>(`${this.apiURL}/e-receipt/setting/${storeCode}`);
  }
  //#endregion

  
  //#region Agent
  
  public getAgentGroupList(page: string | number, rows: number, search: string){
    return this.http.get(`${this.apiURL}/agent/mas-salesperson-group?per_page=${rows}&search=${search}&sort=M_CODE&dir=asc&current_page=${page}&paginate=true`);
  }

  public postUpsertAgentGroup(formData: any){
    return this.http.post<any>(`${this.apiURL}/agent/mas-salesperson-group/upsert`, formData);
  }

  public deleteAgentGroup(M_CODE: any){
    return this.http.delete<any>(`${this.apiURL}/agent/mas-salesperson-group/${M_CODE}`);
  }

  public getAgentGroup(M_CODE:string){
    return this.http.get(`${this.apiURL}/agent/mas-salesperson-group/${M_CODE}`);
  }
  
  public getAgentList(page: string, rows: number, search: string){
    return this.http.get(`${this.apiURL}/agent/mas-salesperson?per_page=${rows}&search=${search}&sort=M_CODE&dir=asc&current_page=${page}&paginate=true`);
  }

  public postUpsertAgent(formData: any){
    return this.http.post<any>(`${this.apiURL}/agent/mas-salesperson/upsert`, formData);
  }

  public deleteAgent(M_CODE: any){
    return this.http.delete<any>(`${this.apiURL}/agent/mas-salesperson/${M_CODE}`);
  }

  public getAgent(M_CODE:string){
    return this.http.get(`${this.apiURL}/agent/mas-salesperson/${M_CODE}`);
  }
  
  // public emailReceipt(formData: any){
  //   return this.http.post<any>(`${this.apiURL}/e-receipt/email`, formData);
  // }

  // public getEReceiptSetting(storeCode: any){
  //   return this.http.get<any>(`${this.apiURL}/e-receipt/setting/${storeCode}`);
  // }
  //#endregion

  //#region Inventory
  public getStockControlList(store_code?: any){

    let params = {
      mas_store: store_code
    }
    if (store_code === null){
      return this.http.get(`${this.apiURL}/inventory/get-stock`);
    }
    else {
      return this.http.get(`${this.apiURL}/inventory/get-stock`, { params});
    }
  }

  public postUpsertTransaction(document_type: any, formData: any){
    let url = this.apiURL;

    switch(document_type){
      case 'stock_in':
        url += `/inventory/stock-in/upsert`;
        break;
      case 'stock_out':
        url += `/inventory/stock-out/upsert`;
        break;
      case 'qty_adjust':
        url += `/inventory/qty-adjustment/upsert`;
        break;
      case 'cost_adjust':
        url += `/inventory/cost-adjustment/upsert`;
        break;
      case 'transfer_in':
        url += `/inventory/transfer-in/upsert`;
        break;
      case 'transfer_out':
        url += `/inventory/transfer-out/upsert`;
        break;
      case 'requisition_note':
        url += `/inventory/requisition-note/upsert`;
        break;
      default:
        return EMPTY;
    }
    return this.http.post<any>(`${url}`, formData);
  }

  public getInventoryList(data : {page: number, rows: number, search: string, type: string, store: any, doc_no: any, doc_date: any, agent: any, status: any}){
    let url = this.apiURL;

    let urlParam = {
      per_page: data?.rows,
      search: data?.search,
      page: data?.page,
      store: data?.store,
      doc_no: data?.doc_no ?? "",
      doc_date: data?.doc_date ?? "",
      agent: data?.agent,
      status: data?.status
    };

    // console.log(params);

    switch(data?.type){
      case 'stock_in':
        url += `/inventory/stock-in`;
        break;
      case 'stock_out':
        url += `/inventory/stock-out`;
        break;
      case 'qty_adjust':
        url += `/inventory/qty-adjustment`;
        break;
      case 'cost_adjust':
        url += `/inventory/cost-adjustment`;
        break;
      case 'transfer_in':
        url += `/inventory/transfer-in`;
        break;
      case 'transfer_out':
        url += `/inventory/transfer-out`;
        break;
      case 'requisition_note':
        url += `/inventory/requisition-note`;
        break;
    }

    return this.http.get(`${url}`, { params: urlParam});

  }
  
  public getInventoryForm(page: string, rows: number, search: string, type: string){
    let url = this.apiURL;

    switch(type){
      case 'stock_in':
        url += `/inventory/stock-in?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'stock_out':
        url += `/inventory/stock-out?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'qty_adjust':
        url += `/inventory/qty-adjustment?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'cost_adjust':
        url += `/inventory/cost-adjustment?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'transfer_in':
        url += `/inventory/transfer-in?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'transfer_out':
        url += `/inventory/transfer-out?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
      case 'requisition_note':
        url += `/inventory/requisition-note?per_page=${rows}&doc_no=${search}&dir=asc&current_page=${page}`;
        break;
    }

    return this.http.get(`${url}`);

  }

  
  public getStockListDetail(type: string, S_DOC_ID: string){
    let url = this.apiURL;

    switch(type){
      case 'stock_in':
        url += `/inventory/stock-in/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'stock_out':
        url += `/inventory/stock-out/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'qty_adjust':
        url += `/inventory/qty-adjustment/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'cost_adjust':
        url += `/inventory/cost-adjustment/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'stock-entry':
        url += `/inventory/stock-out/detail?S_DOC_ID=${S_DOC_ID}`;
        break; 
      case 'transfer_in':
        url += `/inventory/transfer-in/detail?s_doc_id=${S_DOC_ID}`;
        break; 
      case 'transfer_out':
        url += `/inventory/transfer-out/detail?s_doc_id=${S_DOC_ID}`;
        break; 
      case 'requisition_note':
        url += `/inventory/requisition-note/detail?s_doc_id=${S_DOC_ID}`;
        break; 
    }

    return this.http.get(`${url}`);
  }

  // Dropdowns
  public getActiveStore(isViewOnly?: boolean){

    if (isViewOnly === true){
      return this.http.get(`${this.apiURL}/store`);
    }
    else {
      return this.http.get(`${this.apiURL}/dropdown/mas-store`);
    }
  }
  public getActiveAgent(){
    return this.http.get(`${this.apiURL}/dropdown/agents`);
  }
  public getActiveSupplier(include_inactive?: boolean){
    
    let urlParam: any = {};
    if (include_inactive === true){
      urlParam['include_inactive'] =  "true";
    }
    return this.http.get(`${this.apiURL}/dropdown/mas-supplier`, { params: urlParam});
  }
  public getProcessedPR(){
    return this.http.get(`${this.apiURL}/dropdown/list-pr`);
  }
  public getProcessedPO(){
    return this.http.get(`${this.apiURL}/dropdown/list-po`);
  }
    public getProcessedGRN(exclude_inflight: number, include_fully_returned?: number){
    let urlParam: any = {
      include_fully_returned: include_fully_returned ?? 0,
      exclude_inflight: exclude_inflight ?? 1,
    };
    return this.http.get(`${this.apiURL}/dropdown/list-grn`, { params: urlParam });
  }

  public getGRNList(store: string, supplier: string){
    let url = this.apiURL + `/dropdown/list-grn`;
    let urlParam: any = {};
    
    if (store !== null && store !== undefined) {
      urlParam.store = store;
    }
    if (supplier !== null && supplier !== undefined) {
      urlParam.supplier = supplier;
    }
    
    return this.http.get(`${url}`, { params: urlParam});

  }

  public getCurrencyRateList(){
    return this.http.get(`${this.apiURL}/dropdown/list-exchangerates`);
  }

  public getPaymentTermsList(){
    return this.http.get(`${this.apiURL}/dropdown/list-terms`);
  }
  public getPaymentMethodList(){
    return this.http.get(`${this.apiURL}/dropdown/list-payment-methods`);
  }
  public getRawMaterialList(){
    return this.http.get(`${this.apiURL}/dropdown/list-raw-materials`);
  }

  public getStockEnquiryReport(store_code: string, stock_code: string, from_date: string, to_date: string){
    let url = this.apiURL;

    url += `/inventory/report/stock-inquiry?store=${store_code}&from=${from_date}&to=${to_date}&stock_id=${stock_code}`;

    return this.http.get(`${url}`);
  }

  public exportStockEnquiryReport(store_code: string, stock_code: string, from_date: string, to_date: string){
    let url = this.apiURL;

    url += `/inventory/report/stock-inquiry/export?store=${store_code}&from=${from_date}&to=${to_date}&stock_id=${stock_code}`;

    return this.http.get(`${url}`,{ observe: 'response', responseType: 'blob' });
  }

  
  public deleteDraft(type: string, doc_id: string){
    let url = this.apiURL;

    switch(type){
      case 'stock_in':
        url += `/inventory/stock-in/${doc_id}`;
        break;
      case 'stock_out':
        url += `/inventory/stock-out/${doc_id}`;
        break;
      case 'qty_adjust':
        url += `/inventory/qty-adjustment/${doc_id}`;
        break;
      case 'cost_adjust':
        url += `/inventory/cost-adjustment/${doc_id}`;
        break;
      case 'transfer_in':
        url += `/inventory/transfer-in/${doc_id}`;
        break;
      case 'transfer_out':
        url += `/inventory/transfer-out/${doc_id}`;
        break;
      case 'requisition_note':
        url += `/inventory/requisition-note/${doc_id}`;
        break;
    }

    return this.http.delete(`${url}`);
  }

  public getStockTakeList(search: any, page: any, rows: any, index: any){
    
    let urlParam = {
      search: search,
      page: page,
      per_page: rows,
      paginate: true
    };

    let apiUrl = `${this.apiURL}/inventory/stock-take`;

    apiUrl = index == 'entry' ? `${this.apiURL}/inventory/stock-take/list` : apiUrl;



    return this.http.get(apiUrl, { params: urlParam});
  }

  public submitStockTake(formData: any){
    return this.http.post(`${this.apiURL}/inventory/stock-take/prepare`, formData);
  }

  public getStockMovementList(store: any, search: any){
    let urlParam = {
      search,
      store
    }
    return this.http.get(`${this.apiURL}/inventory/stock-take/getStkMovement`, { params: urlParam});
  }

  
  public getEntryDetails(id: any){
    return this.http.get(`${this.apiURL}/inventory/stock-take/${id}/detail`);
  }

  public updateStockEntryQTY(formdata: any){
    return this.http.post(`${this.apiURL}/inventory/stock-take/key-in`, formdata);
  }

  
  public getStockPreparation(S_DOC_ID: any){
    
    let urlParam = {
      search: S_DOC_ID
    }

    return this.http.get(`${this.apiURL}/inventory/stock-take/overview`, {params: urlParam});
  }

  //#endregion

  //#region Settings

  
  public getInventoryFlowSettings(){
    return this.http.get(`${this.apiURL}/inventory/setting/approval/flows`);
  }
  
  public upsertFlowSettings(formData: any){
    return this.http.post(`${this.apiURL}/inventory/setting/approval/flows/upsert`, formData);
  }

  public bulkUpsertFlowSettings(formData: any){
    return this.http.post(`${this.apiURL}/inventory/setting/approval/flows/bulk-upsert`, formData);
  }


  
  public getDefaultCurrencySetting(){
    return this.http.get(`${this.apiURL}/currency/setting`);
  }

  public upsertDefaultCurrency(formData: any){
    return this.http.post(`${this.apiURL}/currency/setting/store`, formData);
  }

  public getAllCurrency(per_page: number, page: number){

    let params = {
      per_page,
      page
    }
    return this.http.get(`${this.apiURL}/currency`, { params });
  }




  

  //#endregion


  //#region Workflow

  public startWorkflow(formData: any){
    return this.http.post(`${this.apiURL}/approvals/start`, formData);
  }

  public workflowAction(id: any, action: any){

    let url = this.apiURL;

    switch(action){
      case 'approve':
        url += `/approvals/${id}/approve`;
        break;
      case 'reject':
        url += `/approvals/${id}/reject`;
        break;
      case 'return':
        url += `/approvals/${id}/return`;
        break;
      default: 
      break;
    }

    let data = {
      note: action
    }
    return this.http.post(`${url}`, data);

  }

  
  public checkApproverStatus(document_id: string){

    let getUserID = localStorage.getItem("userID");
    let getRoleID = localStorage.getItem("role") ?? null;

    if (getRoleID == null){
      this.promptService.openSnackBar("Unable to fetch user role details. Please re-login.");
      return EMPTY;
    }
    else {
      const decryptedBytes = CryptoJS.AES.decrypt(getRoleID, 'QubeAppsPro');
      const decryptedUserData = decryptedBytes.toString(CryptoJS.enc.Utf8);
      getRoleID = JSON.parse(decryptedUserData);
      // console.log(decryptedUserData);
    }

    

    return this.http.get(`${this.apiURL}/approvals/check-approver-by-id/${document_id}/${getUserID}/${getRoleID}`);
  }
  //#endregion

  //#region Notifications

  public getNotification(){
    return this.http.get(`${this.apiURL}/approvals`);
  }

  //#endregion

  //#region Supplier

  public getSupplierClassList() {
    return this.http.get(`${this.apiURL}/supplier-class?sort_by=M_CODE&sort_order=asc&paginate=false`);
  }

  public postUpsertSupplierClass(formData: any) {
    return this.http.post<any>(`${this.apiURL}/supplier-class/upsert`, formData);
  }

  public getSupplierClass(M_CODE: string) {
    return this.http.get(`${this.apiURL}/supplier-class/${M_CODE}`);
  }

  public deleteSupplierClass(data: any) {

    return this.http.delete<any>(`${this.apiURL}/supplier-class/delete`, { body: data });
  }

  public getSupplierGroupList() {
    return this.http.get(`${this.apiURL}/supplier-group?sort_by=M_CODE&sort_order=asc&paginate=false`);
  }

  public postUpsertSupplierGroup(formData: any) {
    return this.http.post<any>(`${this.apiURL}/supplier-group/upsert`, formData);
  }

  public getSupplierGroup(M_CODE: string) {
    return this.http.get(`${this.apiURL}/supplier-group/${M_CODE}`);
  }
  public deleteSupplierGroup(data: any) {

    return this.http.delete<any>(`${this.apiURL}/supplier-group/delete`, { body: data });
  }

  public getSupplierDetailsList(page: number, rows: number, search: string) {
    return this.http.get(`${this.apiURL}/supplier?sort_by=M_CODE&sort_order=asc&paginate=true&per_page=${rows}&page=${page}&search=${search}`);
  }

  public postUpsertSupplierDetails(formData: any) {
    return this.http.post<any>(`${this.apiURL}/supplier/upsert`, formData);
  }

  public getSupplierDetails(M_CODE: string) {
    return this.http.get(`${this.apiURL}/supplier/${M_CODE}`);
  }

  public deleteSupplierDetails(data: any) {

    return this.http.delete<any>(`${this.apiURL}/supplier/delete`, { body: data });
  }


  public getSupplierTransactionList(data: {page: number, rows: number, search: string, type: string, store: any, doc_no: any, doc_date: any, agent: any, status: any}) {
    let url = this.apiURL;
    let urlParam = {
      per_page: data?.rows,
      search: data?.search,
      page: data?.page,
      store: data?.store,
      doc_no: data?.doc_no ?? "",
      doc_date: data?.doc_date ?? "",
      salesperson: data?.agent,
      status: data?.status
    };

    switch (data?.type) {
      case 'purchase_request':
        url += `/supplier/purchase-request/header?paginate=true`;
        break;
      case 'purchase_order':
        url += `/supplier/purchase-order/header?paginate=true`;
        break;
      case 'stock_receive':
        url += `/supplier/stock-receive/header?paginate=true`;
        break;
      case 'stock_return':
        url += `/supplier/stock-return/header?paginate=true`;
        break;
      default:
        return EMPTY;
    }

    return this.http.get(`${url}`, { params: urlParam});

  }

  public postUpsertSupplierTransaction(document_type: any, formData: any) {
    let url = this.apiURL;

    switch (document_type) {
      case 'purchase_request':
        url += `/supplier/purchase-request/upsert`;
        break;
      case 'purchase_order':
        url += `/supplier/purchase-order/upsert`;
        break;
      case 'stock_receive':
        url += `/supplier/stock-receive/upsert`;
        break;
      case 'stock_return':
        url += `/supplier/stock-return/upsert`;
        break;
    }
    return this.http.post<any>(`${url}`, formData);
  }

  public getSupplierTransactionDetail(type: string, S_DOC_ID: string) {
    let url = this.apiURL;

    switch (type) {
      case 'purchase_request':
        url += `/supplier/purchase-request/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'purchase_order':
        url += `/supplier/purchase-order/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'stock_receive':
        url += `/supplier/stock-receive/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
      case 'stock_return':
        url += `/supplier/stock-return/detail?S_DOC_ID=${S_DOC_ID}`;
        break;
    }

    return this.http.get(`${url}`);
  }

  public deleteDraftTransaction(document_type: any, M_CODE: string) {
    let url = this.apiURL;

    switch (document_type) {
      case 'purchase_request':
        url += `/supplier/purchase-request/${M_CODE}`;
        break;
      case 'purchase_order':
        url += `/supplier/purchase-order/${M_CODE}`;
        break;
      case 'stock_receive':
        url += `/supplier/stock-receive/${M_CODE}`;
        break;
      case 'stock_return':
        url += `/supplier/stock-return/${M_CODE}`;
        break;
    }
    return this.http.delete<any>(`${url}`);
  }
  //#endregion
  
  //#region Employee
  
  public getNationalityList(){
    return this.http.get(`${this.apiURL}/dropdown/list-countries`);
  }

  public getEmployeeGroupList(page: string, rows: number, search: string){
    return this.http.get(`${this.apiURL}/employee-group?per_page=${rows}&search=${search}&page=${page}`);
  }

  public getEmployeeGroup(M_CODE:string){
    return this.http.get(`${this.apiURL}/employee-group/${M_CODE}`);
  }
  
  public postUpsertEmployeeGroup(formData: any){
    return this.http.post<any>(`${this.apiURL}/employee-group/upsert`, formData);
  }

  public getEmployeeClassList(page: string, rows: number, search: string){
    return this.http.get(`${this.apiURL}/employee-class?per_page=${rows}&search=${search}&page=${page}`);
  }

  public getEmployeeClass(M_CODE:string){
    return this.http.get(`${this.apiURL}/employee-class/${M_CODE}`);
  }
  public postUpsertEmployeeClass(formData: any){
    return this.http.post<any>(`${this.apiURL}/employee-class/upsert`, formData);
  }

  public getEmployeeDetailsList(page: string, rows: number, search: string){
    return this.http.get(`${this.apiURL}/employee?per_page=${rows}&search=${search}&page=${page}`);
  }
  public getEmployeeDetails(M_CODE:string){
    return this.http.get(`${this.apiURL}/employee/${M_CODE}`);
  }
  public postUpsertEmployeeDetails(formData: any){
    return this.http.post<any>(`${this.apiURL}/employee/upsert`, formData);
  }

  
  public getTimeAttendanceReport(stores: any[], group_by: any, fromDate: string, toDate: string){

    let params: any = null;
    
    params = {
      from: fromDate,
      to: toDate
    }

    if (group_by !== null){
      params['group_by'] = group_by;
    }
    if (stores.length != 0){
      params['stores'] = stores.join("|") ;
    }


    return this.http.get(`${this.apiURL}/time-attendance/report`, { params });
  }

  
  public exportTimeAttendanceReport(stores: any[], group_by: string, fromDate: string, toDate: string) {
 
    
    let params = {
      from: fromDate,
      to: toDate,
      group_by,
      store: stores.join("|")
    }
 
    return this.http.get(`${this.apiURL}/time-attendance/report/export`,{ params, observe: 'response', responseType: 'blob' });
  }

  //#endregion
  
  //#region miscellaneous

  public getExchangeRateList(per_page: number, page: number, base_currency: string, search: string) {
    
    let params = {
      per_page,
      page,
      base_currency,
      manual: true,
      search
    }

    return this.http.get(`${this.apiURL}/currency/exchange-rate`, { params });
  }

  public upsertExchangeRate(formData: any) {
    return this.http.post<any>(`${this.apiURL}/currency/exchange-rate/store`, formData);
  }

  public getExchangeRate(formData: any) {

    return this.http.get(`${this.apiURL}/currency/exchange-rate/get-rate`, { params: formData });
    // return this.http.post<any>(`${this.apiURL}/currency/exchange-rate/get-rate`, formData);
  }
  public deleteExchangeRate(formData: any) {

    return this.http.delete(`${this.apiURL}/currency/exchange-rate/delete`, { params: formData });
    // return this.http.post<any>(`${this.apiURL}/currency/exchange-rate/get-rate`, formData);
  }

  
  //#endregion

  //#region UOM Settings

  public getUOMList(data: {search: string, page: any, per_page: any, paginate: boolean}) {

    let params = {
      per_page: data.per_page,
      search: data.search,
      page: data.page,
      paginate: data.paginate
    }

    return this.http.get(`${this.apiURL}/uom`, { params });
  }
  
  public getUOMCategories() {
    return this.http.get(`${this.apiURL}/uom/categories`);
    // https://fahmy.cloudbite-backend.ddev.site:33003/api/uom/categories/upsert
    // return this.http.post<any>(`${this.apiURL}/uom/categories/upsert`, {addMode: true, code: "W", name: "Weight"});
  }

  
  public upsertUOM(formData: {addMode: boolean, code: string, name: string, category_id?: any, is_system: boolean, is_active: boolean, conversion_factor: any}) {
    return this.http.post<any>(`${this.apiURL}/uom/upsert`, formData);
  }
  public upsertBaseUOM(formData: {name: string, category_name: any, desc: any}) {
    return this.http.post<any>(`${this.apiURL}/uom/base/upsert`, formData);
  }

  public getUOMbyID(id: any){
    return this.http.get(`${this.apiURL}/uom/${id}`);
  }


  




  //#endregion

  //#region Stock UOM

  public upsertStockUOM(formData: any){
    return this.http.post<any>(`${this.apiURL}/item-uoms/upsert`, formData);
  }

  public getStockUOMbyID(id: any){
    return this.http.get(`${this.apiURL}/item-uoms/${id}`);
  }

  
  public getUOMListByBaseUOM(id: any){
    return this.http.get(`${this.apiURL}/dropdown/list-uom?uom_id=${id}`);
  }

  
  public getStockCostByUOM(data:any ){
    return this.http.post(`${this.apiURL}/item-uoms/calc-cost`, data);
  }

  public getStockPrevQTYByUOM(data:any ){
    return this.http.post(`${this.apiURL}/inventory/qty-adjustment/calc-quantity`, data);
  }
  
  public exportStockUOM(){
    return this.http.get(`${this.apiURL}/item-uoms/export`, { observe: 'response', responseType: 'blob' });
  }

  public importStockUOM(formData: any){
    return this.http.post(`${this.apiURL}/item-uoms/import`, formData);
  }

  //#endregion

  //#region BOM
  public getBOMList(data: {search: string, page: any, per_page: any, paginate: boolean}) {

    let params = {
      per_page: data.per_page,
      search: data.search,
      page: data.page,
      paginate: data.paginate
    }

    return this.http.get(`${this.apiURL}/bom/header`, { params });
  }

  public upsertBOM(formData: any){
    return this.http.post<any>(`${this.apiURL}/bom/upsert`, formData);
  }

  public getBOMById(id: any){
    return this.http.get(`${this.apiURL}/bom/detail?bom_id=${id}`);
  }

  public getBOMByStockId(id: any){
    return this.http.get(`${this.apiURL}/bom/by-stock?stock_id=${id}`);
  }

  
  public deleteBOMById(id: any){
    return this.http.delete(`${this.apiURL}/bom/${id}`);
  }

  //#endregion

  //#region Production
  public upsertProduction(formData: any){
    return this.http.post<any>(`${this.apiURL}/production/upsert`, formData);
  }

  public getProductionList(data: {search: string, page: any, per_page: any, paginate: boolean}) {

    let params = {
      per_page: data.per_page,
      search: data.search,
      page: data.page,
      paginate: data.paginate
    }

    return this.http.get(`${this.apiURL}/production/header`, { params });
  }

  public getProductionById(id: any){
    return this.http.get(`${this.apiURL}/production/detail?s_doc_id=${id}`);
  }

  public getProductionReport(data: {store: string, stock_id: any, from: any, to: any}) {
    return this.http.get(`${this.apiURL}/production/report`, { params: data });
  }

  public exportProductionReport(data: {store: string, stock_id: any, start_date: any, end_date: any}) {
    return this.http.get(`${this.apiURL}/production/report/export`, { params: data, observe: 'response', responseType: 'blob' });
  }
  
  public deleteProduction(id: any) {
    return this.http.delete(`${this.apiURL}/production/${id}`);
  }

  //#endregion

  //#region EMenu

  public getEmenuList(data: {search: string, page: any, per_page: any, paginate: boolean}) {

    let params = {
      per_page: data.per_page,
      search: data.search,
      page: data.page,
      paginate: data.paginate
    }

    return this.http.get(`${this.apiURL}/emenu`, { params });
  }

  
  public getCatalog() {
    return this.http.get(`${this.apiURL}/emenu/catalog`);
  }

  public upsertMenu(data: any){
    return this.http.post<any>(`${this.apiURL}/emenu/upsert`, data);
  }

  
  public getMenuById(id: any){
    return this.http.get(`${this.apiURL}/emenu/${id}`);
  }

  
  public deleteMenu(id: any){
    return this.http.delete(`${this.apiURL}/emenu/${id}`);
  }

  
  public getPromotionList(data: {search: string, page: any, per_page: any, paginate: boolean}) {

    let params = {
      per_page: data.per_page,
      search: data.search,
      page: data.page,
      paginate: data.paginate
    }

    return this.http.get(`${this.apiURL}/promotion`, { params });
  }
  
  public getPromotion(id: any){
    return this.http.get(`${this.apiURL}/promotion/${id}`);
  }

  public deletePromotion(id: any){
    return this.http.delete(`${this.apiURL}/promotion/${id}`);
  }

  public upsertPromotion(data: any){
    return this.http.post<any>(`${this.apiURL}/promotion/upsert`, data);
  }

  public getEmenuSettings(){
    return this.http.get(`${this.apiURL}/emenu/settings`);
  }
  public getEmenuPaymentSettings(){
    return this.http.get(`${this.apiURL}/paymentin/emenu`);
  }
  public upsertEmenuPaymentSettings(data: any){
    return this.http.post(`${this.apiURL}/paymentin/emenu/update`, data );
  }
  public getEmenuLoginSettings(){
    return this.http.get(`${this.apiURL}/emenu/login-settings`);
  }
  public upsertEmenuSettings(data: any){
    return this.http.post<any>(`${this.apiURL}/emenu/settings/upsert`, data);
  }
  public upsertLoginSettings(data: any){
    return this.http.post<any>(`${this.apiURL}/emenu/login-settings/upsert`, data);
  }

  public getListLanguage(){
    return this.http.get<any>(`${this.apiURL}/dropdown/list-languages`);
  }

  //#endregion
  
  
  public getActivityLog(data: { module: string, search: string, per_page: string, page: string}){

    const params:any = {
      page: data.page,
      per_page: data.per_page,
      search: data.search ?? "",
      module: data.module
    };

    return this.http.get(`${this.apiURL}/activity-log`, { params });
  }

  public getHolidayByStore(id: any){
    return this.http.get(`${this.apiURL}/holiday/${id}`);
  }

  public getStoreHours(id: any){
    return this.http.get(`${this.apiURL}/store-hours/${id}`);
  }

  public upsertStoreHours(data: any){
    return this.http.post(`${this.apiURL}/store-hours/upsert`, data);
  }

}




